// 价格频道：简体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 业务状态与选项
export const businessDisplay = Object.freeze({
  "priceChannel.businessDisplay.sourceObservationBasis":
    "来源观测：实际批组报价相对首个历史节点的变化（基期=100），不是独立发布指数。",
  "priceChannel.businessDisplay.publishedIndexMissing":
    "当前版本尚无此产品的已发布综合指数；可选择来源查看已有报价历史。",
  "priceChannel.businessDisplay.observationEventsOnly":
    "以下为已发布报价观测记录；新闻事件与外部公告尚未迁入。",
  "priceChannel.businessDisplay.publishedTrendSummary":
    "当前7D窗口 {count} 个已发布指数点；固定版本：{version}",
  "priceChannel.businessDisplay.publishedCoverageSummary":
    "{specs} 项规格 · {sources} 个来源 · {batches} 个库存批组",
  "priceChannel.businessDisplay.announcementsNotPublished":
    "当前版本尚未发布外部研究报告或来源公告，不使用空模板冒充正文。",
  "priceChannel.businessDisplay.latestSourceCoverageBasis":
    "覆盖矩阵依据各批组最新已发布观测日期；不是全历史覆盖率。",
  "priceChannel.businessDisplay.inventoryEventStatus.VALID": "有效",
  "priceChannel.businessDisplay.inventoryEventStatus.EXPIRED": "已过期",
  "priceChannel.businessDisplay.inventoryEventStatus.WITHDRAWN": "已撤回",
  "priceChannel.businessDisplay.condition.NEW": "全新",
  "priceChannel.businessDisplay.condition.OPEN_BOX_NEW": "拆包全新",
  "priceChannel.businessDisplay.condition.OPEN_BOX": "拆包",
  "priceChannel.businessDisplay.condition.UNVERIFIED": "待核验",
  "priceChannel.businessDisplay.packaging.ESD_TRAY": "防静电托盘",
  "priceChannel.businessDisplay.packaging.WAFER_BOX": "晶圆盒",
  "priceChannel.businessDisplay.packaging.FACTORY_TRAY": "原厂托盘",
  "priceChannel.businessDisplay.packaging.RETAIL_BOX": "零售盒",
  "priceChannel.businessDisplay.packaging.ESD_BAG": "防静电袋",
  "priceChannel.businessDisplay.packaging.RETAIL_BLISTER": "零售吸塑",
  "priceChannel.businessDisplay.unit.PCS": "件",
  "priceChannel.businessDisplay.unit.WAFER": "片（晶圆）",
  "priceChannel.businessDisplay.dateCode": "日期代码（Date Code）",
  "priceChannel.businessDisplay.quoteAwaitingTarget": "等待目标价 / 询价",
  "priceChannel.businessDisplay.quoteNeedsDetails": "报价条件待补充",
  "priceChannel.businessDisplay.currencyPending": "币种待补充",
  "priceChannel.businessDisplay.companyTranslationReference":
    "参考译名，仅供展示；法定名称以原文为准",
  "priceChannel.businessDisplay.subject.BRAND": "品牌",
  "priceChannel.businessDisplay.subject.CHANNEL": "渠道",
  "priceChannel.businessDisplay.subject.ENTERPRISE": "企业",
  "priceChannel.businessDisplay.subject.ORGANIZATION": "组织",
  "priceChannel.businessDisplay.subject.XSOU": "先搜",
  "priceChannel.businessDisplay.status.DRAFT": "草稿",
  "priceChannel.businessDisplay.status.SUBMITTED": "已提交",
  "priceChannel.businessDisplay.status.UNDER_REVIEW": "审核中",
  "priceChannel.businessDisplay.status.PENDING": "待处理",
  "priceChannel.businessDisplay.status.LEADER_PENDING": "待领导终审",
  "priceChannel.businessDisplay.status.RETURNED": "已退回",
  "priceChannel.businessDisplay.status.REJECTED": "已拒绝",
  "priceChannel.businessDisplay.status.APPROVED": "已通过",
  "priceChannel.businessDisplay.status.PUBLISHING": "发布中",
  "priceChannel.businessDisplay.status.CALCULATING": "计算中",
  "priceChannel.businessDisplay.status.PUBLISHED": "已发布",
  "priceChannel.businessDisplay.status.PUBLISH_FAILED": "发布失败",
  "priceChannel.businessDisplay.status.CALCULATION_FAILED": "行情计算失败",
  "priceChannel.businessDisplay.status.FAILED": "失败",
  "priceChannel.businessDisplay.status.ACTIVE": "有效",
  "priceChannel.businessDisplay.stage.DEPARTMENT": "部门审核",
  "priceChannel.businessDisplay.stage.LEADER": "领导终审",
  "priceChannel.businessDisplay.stage.OPERATIONS": "运营审核",
  "priceChannel.businessDisplay.decision.APPROVE": "通过",
  "priceChannel.businessDisplay.decision.RETURN": "退回",
  "priceChannel.businessDisplay.decision.REJECT": "拒绝",
  "priceChannel.businessDisplay.outcome.SUCCEEDED": "成功",
  "priceChannel.businessDisplay.outcome.FAILED": "失败",
  "priceChannel.businessDisplay.certification.SELF_OWNED_BRAND": "自有品牌",
  "priceChannel.businessDisplay.certification.AUTHORIZED_PLATFORM": "授权平台",
  "priceChannel.businessDisplay.certification.PARTNER_CHANNEL": "合作渠道",
  "priceChannel.businessDisplay.qualificationType.enterpriseProfile":
    "企业主体资料",
  "priceChannel.businessDisplay.qualificationType.other": "其他价格指数资料",
  "priceChannel.businessDisplay.qualificationMeta.fileName": "文件名",
  "priceChannel.businessDisplay.qualificationMeta.extension": "扩展名",
  "priceChannel.businessDisplay.qualificationMeta.size": "文件大小",
  "priceChannel.businessDisplay.qualificationMeta.selectedAt": "选择时间",
  "priceChannel.businessDisplay.qualificationMeta.demoAttachmentId": "附件标识",
  "priceChannel.businessDisplay.category.flash-wafer": "闪存晶圆",
  "priceChannel.businessDisplay.category.memory-wafer": "内存晶圆",
  "priceChannel.businessDisplay.category.flash-chip": "闪存芯片",
  "priceChannel.businessDisplay.category.memory-chip": "内存芯片",
  "priceChannel.businessDisplay.category.memory-module": "内存条",
  "priceChannel.businessDisplay.category.solid-state-drive": "固态硬盘",
  "priceChannel.businessDisplay.category.flash-card": "闪存卡",
  "priceChannel.businessDisplay.category.embedded-storage": "嵌入式存储器",
  "priceChannel.businessDisplay.category.usb-flash-drive": "USB闪存盘",
  "priceChannel.businessDisplay.dimension.wafer-device-kind": "类型",
  "priceChannel.businessDisplay.dimension.flash-memory-kind": "类型",
  "priceChannel.businessDisplay.dimension.flash-cell-type": "制程",
  "priceChannel.businessDisplay.dimension.dram-generation": "代际",
  "priceChannel.businessDisplay.dimension.bit-density-gbit": "容量",
  "priceChannel.businessDisplay.dimension.byte-capacity-gbyte": "容量",
  "priceChannel.businessDisplay.dimension.clock-mhz": "频率",
  "priceChannel.businessDisplay.dimension.data-rate-mtps": "速率",
  "priceChannel.businessDisplay.dimension.bus-width": "位宽",
  "priceChannel.businessDisplay.dimension.organization": "组织",
  "priceChannel.businessDisplay.dimension.stack-layer-count": "层数",
  "priceChannel.businessDisplay.dimension.wafer-diameter-mm": "直径",
  "priceChannel.businessDisplay.dimension.interface-rate-mtps": "速率",
  "priceChannel.businessDisplay.dimension.package": "封装",
  "priceChannel.businessDisplay.dimension.package-structure": "结构",
  "priceChannel.businessDisplay.dimension.protocol-version": "协议",
  "priceChannel.businessDisplay.dimension.interface-generation": "接口",
  "priceChannel.businessDisplay.dimension.form-factor": "形态",
  "priceChannel.businessDisplay.dimension.ecc-capability": "ECC",
  "priceChannel.businessDisplay.dimension.rank": "Rank",
  "priceChannel.businessDisplay.dimension.speed-class": "等级",
  "priceChannel.businessDisplay.value.bare-die": "裸Die",
  "priceChannel.businessDisplay.value.packaged-ic": "封装颗粒",
  "priceChannel.businessDisplay.value.not-applicable": "不适用",
  "priceChannel.businessDisplay.value.single-die": "单Die",
  "priceChannel.businessDisplay.value.multi-die": "多Die",
  "priceChannel.businessDisplay.value.2.5-inch": "2.5英寸",
  "priceChannel.businessDisplay.value.consumer": "消费级",
  "priceChannel.businessDisplay.value.enterprise": "企业级",
  "priceChannel.businessDisplay.value.secondary-market": "二级市场",
  "priceChannel.businessDisplay.value.managed-package": "管理封装",
  "priceChannel.businessDisplay.value.usb-mass-storage": "USB大容量存储",
  "priceChannel.businessDisplay.value.high-speed": "高速",
  "priceChannel.businessDisplay.value.usb-flash-drive": "U盘",
  "priceChannel.businessDisplay.formInvalid": "表单内容无效，请检查各字段",
  "priceChannel.businessDisplay.reviewInvalid":
    "审核内容无效，请核对意见与版本后重试",
  "priceChannel.businessDisplay.originalContentHint":
    "下方用户填写的内容及审核意见为原文；切换界面语言不会改写原始记录。",
  "priceChannel.businessDisplay.validation.array": "{field}需要填写为数组",
  "priceChannel.businessDisplay.validation.arrayLimit": "{field}最多填写100项",
  "priceChannel.businessDisplay.validation.fileId": "第{index}项缺少文件ID",
  "priceChannel.businessDisplay.validation.arrayEntry": "第{index}项格式无效",
  "priceChannel.businessDisplay.validation.text": "{field}必须填写文字",
  "priceChannel.businessDisplay.validation.arrayRequired":
    "第{index}项缺少{field}",
  "priceChannel.businessDisplay.validation.dimensionValue":
    "第{index}项缺少规格值或选项ID",
  "priceChannel.businessDisplay.validation.decimal":
    "{field}{location}必须是非负十进制数",
  "priceChannel.businessDisplay.validation.currency":
    "第{index}项币种须为三位大写代码",
  "priceChannel.businessDisplay.validation.required": "请填写{field}",
});

// 行情界面
export const market = Object.freeze({
  "priceChannel.title": "价格指数",
  "priceChannel.channelName": "价格频道",
  "priceChannel.market": "行情",
  "priceChannel.categories": "分类",
  "priceChannel.watchlist": "自选",
  "priceChannel.my": "我的",
  "priceChannel.personalNavigation": "价格频道个人中心导航",
  "priceChannel.messageCenter": "消息中心",
  "priceChannel.primaryNavigation": "价格频道主导航",
  "priceChannel.marketNavigation": "价格指数导航",
  "priceChannel.navigationHint": "单击恢复上次位置，双击刷新当前页面",
  "priceChannel.brandFilter": "品牌",
  "priceChannel.marketFilter": "正式版行情产品分类与品牌筛选",
  "priceChannel.categoryHeading": "分类行情",
  "priceChannel.productCategory": "产品分类",
  "priceChannel.applicationReview": "申报审核",
  "priceChannel.applicationReviewCount": "申报审核 ({count})",
  "priceChannel.invalidRegionRoute":
    "URL中的地区无法识别，请清除地区或重新选择；未扩大到全部来源。",
  "priceChannel.invalidCategoryRoute":
    "URL中的产品分类无法识别，请重新选择产品大类。",
  "priceChannel.regionLoadFailed": "地区报价加载失败，请重新选择地区。",
  "priceChannel.categoryDescription":
    "选择一个产品大类，再按任意维度逐步收窄行情范围。",
  "priceChannel.viewMultidimensional": "查看多维行情",
  "priceChannel.myWatchlist": "我的自选",
  "priceChannel.myFavorites": "我的收藏",
  "priceChannel.itemsCount": "{count} 项",
  "priceChannel.viewAll": "查看全部",
  "priceChannel.noFavorites": "还没有收藏",
  "priceChannel.favoritesHint":
    "点击行情卡片右上角的“＋”，把关注对象放到这里。",
  "priceChannel.allBrands": "全部品牌",
  "priceChannel.marketOverview": "市场概览",
  "priceChannel.levelOneMarket": "一级行情",
  "priceChannel.sampleSources": "{samples} 样本 · {sources} 来源",
  "priceChannel.marketMovers": "行情异动",
  "priceChannel.mover.positive": "涨跌幅降序",
  "priceChannel.mover.negative": "涨跌幅升序",
  "priceChannel.mover.latest": "最新更新",
  "priceChannel.noMatchingMarket": "当前频道暂无对应行情",
  "priceChannel.hotDiscovery": "热门发现",
  "priceChannel.hotDiscoveryTypes": "热门发现类型",
  "priceChannel.popularMarkets": "热门行情",
  "priceChannel.popularProducts": "热门产品",
  "priceChannel.multidimensionalMarket": "多维行情",
  "priceChannel.regionalHotProducts": "多地区热门产品",
  "priceChannel.brandActivity": "品牌活跃",
  "priceChannel.productCategories": "{products} 个产品 · {categories} 个分类",
  "priceChannel.updatedAt": "更新 {time}",
  "priceChannel.sourceActivity": "来源动态",
  "priceChannel.registeredSources": "{count} 个登记来源",
  "priceChannel.recentAt": "最近 {time}",
  "priceChannel.majorPlatform": "大型平台",
  "priceChannel.partnerChannel": "合作渠道",
  "priceChannel.marketPerformance": "市场表现",
  "priceChannel.regionFilter": "报价来源地区筛选",
  "priceChannel.noMatchingRegion": "没有匹配地区",
  "priceChannel.region.country": "国家",
  "priceChannel.region.admin": "省/州",
  "priceChannel.region.city": "城市",
  "priceChannel.currentNext": "当前为{current}，点击切换为{next}",
  "priceChannel.next": "点击切换为{next}",
  "priceChannel.sort.DEFAULT": "默认报价",
  "priceChannel.sort.VALUE": "最优报价",
  "priceChannel.sort.VALUE.basis":
    "按综合指数从低到高排列，并非实时最低可成交报价",
  "priceChannel.sort.LATEST": "最新报价",
  "priceChannel.view.charts": "图表",
  "priceChannel.view.list": "列表",
  "priceChannel.multidimensionalFilter": "多维行情筛选",
  "priceChannel.addFavorite": "加入收藏",
  "priceChannel.chooseWatchlist": "请选择自选分组",
  "priceChannel.watchlistAdded": "已加入自选",
  "priceChannel.watchlistManage": "管理全部自选",
  "priceChannel.watchlistSignIn": "登录后可查看自己的自选行情。",
  "priceChannel.removeFavorite": "取消收藏",
  "priceChannel.searchResultsFor": "{name}搜索结果",
  "priceChannel.selectionPath": "当前行情分类路径",
  "priceChannel.emptyScopeTitle": "当前恢复条件已无可用产品",
  "priceChannel.emptyScopeHint":
    "保留原筛选条件，移除失效条件后可继续查看行情。",
  "priceChannel.removeCondition": "移除{condition}",
  "priceChannel.dimension": "维度",
  "priceChannel.cachedCondition": "缓存条件",
  "priceChannel.condition": "条件",
  "priceChannel.unknown": "未知",
  "priceChannel.regionRelated": "地区相关",
  "priceChannel.regionRelatedGroup": "地区相关：{name}",
  "priceChannel.regionRelatedLoadRetry": "地区行情加载失败，点击重试",
  "priceChannel.regionRelatedPreparing": "正在整理相关地区…",
  "priceChannel.hidePageArrows": "隐藏组内翻页箭头",
  "priceChannel.showPageArrows": "显示组内翻页箭头",
  "priceChannel.batchPending": "批次待核验",
  "priceChannel.availableQuantity": "可售数量",
  "priceChannel.fabricationInfo": "出厂信息",
  "priceChannel.packaging": "包装",
  "priceChannel.conditionLabel": "货况",
  "priceChannel.stockLocation": "库存地点",
  "priceChannel.minimumOrderQuantity": "最小起订量",
  "priceChannel.deliveryLeadTime": "交期",
  "priceChannel.quantityTiers": "数量阶梯",
  "priceChannel.noQuantityTiers": "当前报价未提供数量阶梯",
  "priceChannel.quoteHistory": "报价历史",
  "priceChannel.status.ACTIVE": "有效",
  "priceChannel.status.EXPIRED": "已过期",
  "priceChannel.status.SOLD_OUT": "已售罄",
  "priceChannel.status.WITHDRAWN": "已撤回",
  "priceChannel.resolution.EXACT": "批次明确",
  "priceChannel.resolution.PROBABLE": "推定归并",
  "priceChannel.resolution.UNKNOWN": "信息待补",
  "priceChannel.quoteSource": "报价来源",
  "priceChannel.sourceBatches": "来源与批组",
  "priceChannel.partBatches": "料号与批组",
  "priceChannel.switchToSources": "切换为报价来源浏览",
  "priceChannel.switchToParts": "切换为标准料号浏览",
  "priceChannel.batchSourceCount": "{batches} 个批组 · {sources} 个来源",
  "priceChannel.partActiveCount": "{parts} 个料号 · {active}/{total} 个有效",
  "priceChannel.noValidQuote": "暂无有效报价",
  "priceChannel.none": "暂无",
  "priceChannel.quantityUnknown": "数量未知",
  "priceChannel.timePending": "时间待补充",
  "priceChannel.realtimeQuotes": "实时报价",
  "priceChannel.sourceCount": "{count} 个来源",
  "priceChannel.currentQuote": "当前报价 / TP",
  "priceChannel.productionMark": "生产标记",
  "priceChannel.moq": "MOQ",
  "priceChannel.latestTime": "最新时间",
  "priceChannel.noApprovedQuotes": "当前暂无已审核报价",
  "priceChannel.coverageMatrix": "来源覆盖矩阵",
  "priceChannel.coverageHint": "来源与日期覆盖情况",
  "priceChannel.source": "来源",
  "priceChannel.covered": "已覆盖",
  "priceChannel.noCoverage": "暂无来源覆盖信息",
  "priceChannel.multiSeriesTrend": "行情标的多序列趋势图",
  "priceChannel.noChartData": "当前暂无可展示数据",
  "priceChannel.pendingDetail": "待补充",
  "priceChannel.indexTrend": "行情指数趋势",
  "priceChannel.pointAria": "{name}，{time}，指数{value}",
  "priceChannel.dailyClose": "收盘 {close} · 昨收 {previous} · 日涨跌 {change}",
  "priceChannel.sourceVisibility": "趋势来源显示控制",
  "priceChannel.hideAll": "取消全部",
  "priceChannel.showAll": "展示全部",
  "priceChannel.sectorIndex": "{name}行情指数",
  "priceChannel.sectorTrend": "{name}行情指数趋势",
  "priceChannel.indexPeriod": "行情指数周期",
  "priceChannel.customRangeFailed": "无法应用该时间范围",
  "priceChannel.industryScope": "行业相关行情范围",
  "priceChannel.dimensionCandidates": "{name}候选值",
  "priceChannel.technicalCandidates": "技术族候选值",
  "priceChannel.backHome": "返回行情首页",
  "priceChannel.dataCutoff": "数据截止 {time}",
  "priceChannel.backCategory": "返回分类",
  "priceChannel.retry": "重试",
  "priceChannel.loadingRelease": "正在读取当前行情版本…",
  "priceChannel.currentScope": "当前板块",
  "priceChannel.relatedProducts": "{count} 个相关产品",
  "priceChannel.scopeTrend": "当前板块指数趋势",
  "priceChannel.scopePending": "当前筛选范围正在计算，尚未进入公开行情版本。",
  "priceChannel.scopeRecovering":
    "计算等待较久，当前页每 10 秒检查一次；已有内容仍可使用。",
  "priceChannel.scopeRecoveryStopped":
    "本次自动检查已结束，计算可能仍在后台进行；可重试查询状态。",
  "priceChannel.relationRecoveryStopped":
    "部分关联曲线仍未就绪，自动补读已结束；重试只补缺失曲线。",
  "priceChannel.scopeFailed": "当前筛选范围计算未完成，请稍后重试。",
  "priceChannel.scopeEmpty": "当前范围暂无可展示的产品指数。",
  "priceChannel.categoryEmpty": "当前分类暂无可展示的行情。",
  "priceChannel.loadingMore": "正在加载…",
  "priceChannel.loadMore": "加载更多",
  "priceChannel.instrumentIndex": "具体产品指数",
  "priceChannel.instrument": "具体产品",
  "priceChannel.instrumentTrend": "{name}指数趋势",
  "priceChannel.instrumentEmpty": "该产品当前版本暂无指数点。",
  "priceChannel.partNumbers": "料号",
  "priceChannel.partNumbersEmpty": "当前版本暂无公开料号。",
  "priceChannel.compositeIndex": "综合指数",
  "priceChannel.missing": "缺失",
  "priceChannel.pending": "待确认",
  "priceChannel.product": "产品",
  "priceChannel.serviceUnavailable": "价格频道服务暂不可用，请稍后重试。",
  "priceChannel.releaseExpired": "当前行情版本已过期，请重新加载。",
  "priceChannel.viewForbidden": "当前身份没有查看此数据的权限。",
  "priceChannel.loadFailed": "行情读取失败，请稍后重试。",
  "priceChannel.identityRestoring": "正在恢复价格频道身份…",
  "priceChannel.businessEyebrow": "我的 · 价格频道",
  "priceChannel.viewMarket": "查看行情指数",
  "priceChannel.identityChecking": "正在确认当前账号的价格频道身份…",
  "priceChannel.currentAccount": "当前商城账号",
  "priceChannel.account": "账号 {id}",
  "priceChannel.identity": "价格频道身份",
  "priceChannel.noIdentity": "此商城账号尚无有效价格频道身份。",
  "priceChannel.authorizedScopes": "{count} 个获授权主体范围",
  "priceChannel.businessNavigation": "价格频道业务",
  "priceChannel.businessForbidden": "当前身份没有此业务入口权限。",
  "priceChannel.backIdentity": "返回频道身份",
  "priceChannel.availableBusiness": "当前可用业务",
  "priceChannel.bindIdentity":
    "请先由业务管理员给当前商城账号绑定有效会员身份。",
  "priceChannel.noBusiness": "当前身份暂无可操作的价格频道业务。",
  "priceChannel.refresh": "刷新",
  "priceChannel.reading": "正在读取…",
  "priceChannel.noRecords": "当前没有相关记录。",
  "priceChannel.watchlistItems": "{count} 项自选",
  "priceChannel.memberIdentity": "会员身份",
  "priceChannel.section.identity": "频道身份",
  "priceChannel.section.activity": "消息中心",
  "priceChannel.section.watchlists": "行情自选",
  "priceChannel.section.certifications": "企业认证",
  "priceChannel.section.submissions": "业务上报",
  "priceChannel.section.reviews": "审核待办",
  "priceChannel.section.results": "审查结果",
  "priceChannel.activity.all": "全部",
  "priceChannel.activity.market": "行情关注",
  "priceChannel.activity.inventory": "料号 / 库存",
  "priceChannel.activity.workflow": "业务流程",
  "priceChannel.activity.system": "系统",
  "priceChannel.activityProjectionHint":
    "仅汇总当前身份可读的上报与待审状态；这是活动投影，不是已推送通知。",
  "priceChannel.activitySourceUnavailable":
    "该类通知尚无正式事件接口，当前不展示模拟消息。",
  "priceChannel.watchlistName": "自选分组名称",
  "priceChannel.createWatchlist": "创建分组",
  "priceChannel.removeWatchlistItem": "移除自选项",
  "priceChannel.invalidSelection":
    "原链接中的部分筛选条件未能映射到当前发布目录，请重新选择。",
  "priceChannel.loginExpired": "登录已失效，请重新登录。",
  "priceChannel.accountForbidden": "当前账号或身份没有访问权限。",
  "priceChannel.businessUnavailable": "价格频道业务服务暂不可用，请稍后重试。",
  "priceChannel.readFailed": "读取失败，请稍后重试。",
  "priceChannel.role.platform_leader": "平台领导",
  "priceChannel.role.company_business": "企业业务",
  "priceChannel.role.company_operations": "企业运营",
  "priceChannel.role.self_owned_brand": "自有品牌",
  "priceChannel.role.authorized_platform": "授权平台",
  "priceChannel.role.partner_channel": "合作渠道",
  "priceChannel.role.readonly_customer": "只读客户",
  "priceChannel.submissions": "业务上报",
  "priceChannel.submission.PRODUCT": "具体产品",
  "priceChannel.submission.PART_NUMBER": "标准料号",
  "priceChannel.submission.INVENTORY": "库存批组",
  "priceChannel.submission.OFFER": "报价观察",
  "priceChannel.field.instrumentId": "具体产品 ID",
  "priceChannel.field.partNumberId": "标准料号 ID",
  "priceChannel.field.categoryId": "分类 ID *",
  "priceChannel.field.brandRef": "品牌引用 *",
  "priceChannel.field.code": "产品代码 *",
  "priceChannel.field.title": "产品名称 *",
  "priceChannel.field.instrumentKind": "产品类型 *",
  "priceChannel.field.dimensions": "技术维度",
  "priceChannel.field.evidenceRefs": "证明文件引用",
  "priceChannel.field.manufacturerPartNumber": "原厂料号 *",
  "priceChannel.field.attributes": "料号属性",
  "priceChannel.field.batchId": "库存批组 ID",
  "priceChannel.field.sourceProviderId": "报价来源 ID *",
  "priceChannel.field.batchCode": "批次代码",
  "priceChannel.field.dateCode": "Date Code",
  "priceChannel.field.originRegionId": "出厂地区 ID",
  "priceChannel.field.stockRegionId": "库存地区 ID",
  "priceChannel.field.packaging": "包装",
  "priceChannel.field.condition": "货况",
  "priceChannel.field.stockQuantity": "库存数量 *",
  "priceChannel.field.quantityUnit": "数量单位 *",
  "priceChannel.field.minimumOrderQuantity": "最小订购量",
  "priceChannel.field.inventoryBatchId": "库存批组 ID *",
  "priceChannel.field.amount": "单价 *",
  "priceChannel.field.currency": "币种 *",
  "priceChannel.field.priceUnit": "报价单位 *",
  "priceChannel.field.observedAt": "报价时间（ISO 8601）*",
  "priceChannel.field.expiresAt": "有效期（ISO 8601）",
  "priceChannel.field.sourceRecordId": "来源记录 ID",
  "priceChannel.field.sourceRevision": "来源修订",
  "priceChannel.field.tiers": "数量阶梯",
  "priceChannel.array.dimensionId": "维度 ID *",
  "priceChannel.array.optionId": "选项 ID",
  "priceChannel.array.normalizedValue": "规格值",
  "priceChannel.array.unit": "单位",
  "priceChannel.array.attributeCode": "属性代码 *",
  "priceChannel.array.label": "属性名称",
  "priceChannel.array.value": "属性值",
  "priceChannel.array.minimumQuantity": "起订量 *",
  "priceChannel.array.maximumQuantity": "最大数量",
  "priceChannel.array.amount": "单价 *",
  "priceChannel.array.currency": "币种 *",
  "priceChannel.array.priceUnit": "报价单位 *",
  "priceChannel.array.fileId": "文件 ID {index}",
  "priceChannel.array.addNamed": "添加{label}",
  "priceChannel.array.remove": "删除该项",
  "priceChannel.array.removeNamed": "删除第 {index} 项{label}",
  "priceChannel.field.existingInstrumentId": "已有产品 ID（新建留空）",
  "priceChannel.field.requiredInstrumentId": "具体产品 ID *",
  "priceChannel.field.existingPartNumberId": "已有料号 ID（新建留空）",
  "priceChannel.field.existingBatchId": "已有批组 ID（新建留空）",
  "priceChannel.closeDraft": "收起草稿",
  "priceChannel.newDraft": "新建草稿",
  "priceChannel.draftHint":
    "草稿保存在业务数据库，正文由 Platform 保存为不可变修订；保存不会自动送审。",
  "priceChannel.noAuthorizedSubject":
    "当前身份没有获授权主体，不能创建业务上报。",
  "priceChannel.subject": "上报主体",
  "priceChannel.chooseSubject": "请选择获授权主体",
  "priceChannel.submissionType": "上报类型",
  "priceChannel.saving": "保存中…",
  "priceChannel.saveDraft": "保存草稿",
  "priceChannel.saveChanges": "保存修订",
  "priceChannel.resumeReturnedDraft": "恢复退回草稿",
  "priceChannel.originalSubmissionFields": "上报正文",
  "priceChannel.readingSubmissions": "正在读取上报记录…",
  "priceChannel.noSubmissions": "暂无上报记录。",
  "priceChannel.publicationRequest": "发布申请 {id}",
  "priceChannel.awaitRelease": "等待公开版本",
  "priceChannel.viewStatus": "查看状态",
  "priceChannel.submitForReview": "送审",
  "priceChannel.confirmReview":
    "确认将当前不可变修订送运营审核？保存后不能原位改写。",
  "priceChannel.confirmSubmit": "确认送审",
  "priceChannel.cancel": "取消",
  "priceChannel.businessStatus": "业务状态",
  "priceChannel.version": "版本",
  "priceChannel.revision": "修订引用",
  "priceChannel.releaseVersion": "发布版本",
  "priceChannel.notActivated": "尚未激活",
  "priceChannel.publicationStage": "发布阶段",
  "priceChannel.publicationReceiptTimeline": "发布回执时间线",
  "priceChannel.publicationTimelineUnavailable":
    "当前详情未提供完整的发布回执字段，请确认后端版本；不以当前状态推断历史。",
  "priceChannel.publicationReceiptTimeHint":
    "以下按商城收到回执的时间排列，并非业务发生时间；回执顺序不代表当前状态回退。",
  "priceChannel.publicationTimelineTruncated":
    "仅展示最近200条回执，更早记录未在此页加载。",
  "priceChannel.noPublicationReceipt": "尚无发布回执记录。",
  "priceChannel.publicationReceiptStage.FACT_ACCEPTED": "事实接收",
  "priceChannel.publicationReceiptStage.MARKET_RELEASE_ACTIVATED":
    "公开版本激活",
  "priceChannel.publicationFactPending": "事实入库待确认，尚未公开",
  "priceChannel.publicationCalculating": "事实已接受，等待指数与公开版本",
  "priceChannel.publicationActivated": "公开版本 {version} 已激活",
  "priceChannel.submissionPayloadUnavailable":
    "当前详情缺少经后端修订校验的正文，无法核对原上报字段。",
  "priceChannel.submissionTimelineUnavailable":
    "后端详情尚未返回完整审核时间线，不能用当前状态推断历史节点。",
  "priceChannel.returnRecoveryUnavailable":
    "退回后恢复编辑需读取原修订正文；当前详情不完整，暂不可安全恢复。",
  "priceChannel.submissionReadFailed": "上报记录读取失败",
  "priceChannel.subjectRequired": "请选择获授权的上报主体",
  "priceChannel.draftSaved": "草稿 {id} 已保存，可在下方明确送审。",
  "priceChannel.draftSaveFailed": "草稿保存失败，可重试原请求",
  "priceChannel.draftChanged": "草稿已变化，请刷新后重试",
  "priceChannel.submitted": "已送交运营审核。",
  "priceChannel.submitFailed": "送审失败",
  "priceChannel.detailReadFailed": "上报详情读取失败",
  "priceChannel.reviewHint":
    "仅展示当前 Spring 身份和主体范围内的待办；每次审核会重新读取版本，最终由服务端校验。",
  "priceChannel.readingReviews": "正在读取审核队列…",
  "priceChannel.noReviews": "当前没有待审事项。",
  "priceChannel.operationsReview": "运营审核",
  "priceChannel.viewDetail": "查看详情",
  "priceChannel.approve": "通过",
  "priceChannel.return": "退回",
  "priceChannel.reject": "拒绝",
  "priceChannel.currentVersion": "当前版本 {version}",
  "priceChannel.typeRevision": "类型 {type} · 修订 {revision}",
  "priceChannel.evidenceCount": "证明材料 {count} 份",
  "priceChannel.reviewPayloadUnavailable":
    "当前详情缺少经后端修订校验的上报正文与审核记录，不能在未核对内容时审核。",
  "priceChannel.reviewContentChanged": "待审内容已变化，请重新查看后再决定",
  "priceChannel.confirmDecision": "确认{decision}？",
  "priceChannel.reviewOpinion": "审核意见（1–25 字）",
  "priceChannel.processing": "处理中…",
  "priceChannel.confirmAction": "确认提交",
  "priceChannel.certificationTitle": "企业认证 · {id}",
  "priceChannel.reviewReadFailed": "待办读取失败",
  "priceChannel.reviewDetailReadFailed": "审核详情读取失败",
  "priceChannel.reviewDone":
    "审核已{decision}；公开行情仍须等待发布与 Release 激活。",
  "priceChannel.reviewFailed": "审核失败，请刷新后重试",
  "priceChannel.closeApplication": "收起申请",
  "priceChannel.startCertification": "发起认证",
  "priceChannel.noEnterpriseSubject":
    "当前身份没有获授权的企业主体，无法发起认证。",
  "priceChannel.certificationSubject": "认证主体",
  "priceChannel.certificationType": "认证类型",
  "priceChannel.evidenceMaterials": "证明材料",
  "priceChannel.evidencePickerHint":
    "从当前账号的可见文件库选择，最多 {max} 份；不会提交路径或 URL。",
  "priceChannel.removeEvidence": "移除证明文件 {name}",
  "priceChannel.readingFiles": "读取中…",
  "priceChannel.refreshFiles": "刷新文件库",
  "priceChannel.fileLibraryHint":
    "仅引用当前账号文件库中已完成的文件；不上传路径或 URL。最多 20 份。",
  "priceChannel.noFiles": "文件库暂无可选文档，请先在个人文件库上传。",
  "priceChannel.fileNumber": "文件 {id}",
  "priceChannel.submitting": "提交中…",
  "priceChannel.submitCertification": "提交认证申请",
  "priceChannel.readingCertifications": "正在读取认证记录…",
  "priceChannel.noCertifications": "暂无认证申请。",
  "priceChannel.applicationNumber": "申请号 {id}",
  "priceChannel.viewReviewHistory": "查看审核记录",
  "priceChannel.currentStage": "当前阶段：{stage}",
  "priceChannel.awaitProcessing": "待处理",
  "priceChannel.noReviewEvent": "尚无审核事件。",
  "priceChannel.noOpinion": "未填写意见",
  "priceChannel.certificationReadFailed": "认证记录读取失败",
  "priceChannel.filesReadFailed": "文件库读取失败",
  "priceChannel.certificationRequired":
    "请选择获授权主体、认证类型和 1–20 份证明材料",
  "priceChannel.certificationSaved": "认证申请已保存到业务系统。",
  "priceChannel.certificationFailed": "认证申请失败",
  "priceChannel.reviewHistoryReadFailed": "审核记录读取失败",
  "priceChannel.reviewResults": "审查结果",
  "priceChannel.noReviewResult": "当前类型暂无已审记录。",
  "priceChannel.resultListIncomplete": "审查结果列表数据不完整，请稍后重试。",
  "priceChannel.resultLinkInvalid":
    "审查结果链接的类型或业务 ID 无效；旧演示编号尚未建立正式映射。",
  "priceChannel.resultDetailIncomplete":
    "审查详情缺少原始内容或审核时间线，无法安全展示。",
  "priceChannel.reviewResultsDescription":
    "集中查看企业认证、产品上报与料号上报的已完成审查结果。",
  "priceChannel.reviewResultTypes": "审查结果类型",
  "priceChannel.reviewResultsFor": "{type}审查结果",
  "priceChannel.noReviewResultsFor": "{type}暂无已完成审查结果",
  "priceChannel.closeDetail": "收起详情",
  "priceChannel.statusTimeline": "状态轨迹",
  "priceChannel.resultGroup.certification": "企业认证",
  "priceChannel.resultGroup.product": "产品上报",
  "priceChannel.resultGroup.part-number": "料号上报",
  "priceChannel.backToCategory": "返回{name}",
  "priceChannel.profileSections": "行情档案章节",
  "priceChannel.sectionNav.market": "趋势",
  "priceChannel.sectionNav.spec": "料号",
  "priceChannel.sectionNav.comparison": "行情",
  "priceChannel.sectionNav.overview": "概览",
  "priceChannel.sectionNav.events": "事件",
  "priceChannel.sectionNav.research": "研究",
  "priceChannel.sectionNav.sources": "来源",
  "priceChannel.compositeTrend": "综合趋势与来源观测",
  "priceChannel.timeRange": "行情时间范围",
  "priceChannel.inventoryTitle": "料号与库存批组",
  "priceChannel.partBackground": "料号与规格背景",
  "priceChannel.noPublishedParts": "暂无已发布料号",
  "priceChannel.publishedPartsHint":
    "产品档案已发布；料号、库存批组与报价通过审核后将在此自动补齐。",
  "priceChannel.objectLevel": "对象层级",
  "priceChannel.objectLevelHint":
    "当前对象用于聚合同一标准规格，具体料号以公开展示内容为准。",
  "priceChannel.trendBoundary": "趋势输入边界",
  "priceChannel.trendBoundaryHint":
    "只有规格、来源和时间口径一致的样本才进入趋势计算。",
  "priceChannel.specificParts": "具体料号",
  "priceChannel.partLoadRetry": "料号加载失败，点击重试",
  "priceChannel.partPreparing": "正在准备料号信息…",
  "priceChannel.marketRelated": "行情相关",
  "priceChannel.industryRelated": "行业相关",
  "priceChannel.relatedLoadRetry": "行情加载失败，点击重试",
  "priceChannel.relatedPreparing": "正在准备相关行情…",
  "priceChannel.noRelatedMarkets": "暂无可关联行情",
  "priceChannel.relatedHint":
    "当前产品事实已公开，待同规格产品或上位行情形成后自动建立关联。",
  "priceChannel.productOverview": "产品与规格概览",
  "priceChannel.productIndex": "产品指数",
  "priceChannel.brandProfile": "{brand}品牌档案",
  "priceChannel.brand": "品牌",
  "priceChannel.productKind": "产品总类 / 细分",
  "priceChannel.standardSpecification": "标准规格",
  "priceChannel.representativePart": "代表料号",
  "priceChannel.trendBasis": "趋势口径",
  "priceChannel.application": "应用",
  "priceChannel.latestIndex": "最新指数",
  "priceChannel.sevenDayChange": "近7日变化",
  "priceChannel.dailyChange": "日涨跌幅",
  "priceChannel.sevenDayBasis": "当前指数相对7D区间昨收",
  "priceChannel.totalSamples": "累计样本",
  "priceChannel.anonymizedSources": "{count}类脱敏来源口径",
  "priceChannel.marketEvents": "行情事件",
  "priceChannel.research": "研究与公告",
  "priceChannel.researchItem.0.title": "行情摘要",
  "priceChannel.researchItem.0.detail":
    "近30日固定序列、样本覆盖和同类标的差异的本地摘要。",
  "priceChannel.researchItem.1.title": "规格摘要",
  "priceChannel.researchItem.1.detail":
    "集中展示代表料号、封装、速率或良率等公开规格信息。",
  "priceChannel.researchItem.2.title": "来源公告位",
  "priceChannel.researchItem.2.detail":
    "正式上线后用于展示授权来源公告与公开引用。",
  "priceChannel.sourceCoverage": "来源覆盖",
  "priceChannel.sourceLoadRetry": "来源加载失败，点击重试",
  "priceChannel.sourcePreparing": "正在准备来源覆盖…",
  "priceChannel.profileCompanyMark": "产品档案公司标识",
  "priceChannel.profileEnd": "PRICE INDEX · 档案末尾",
  "priceChannel.profileEndHint": "可信数据链路 · DEMO 档案浏览结束",
  "priceChannel.detailLoading": "正在加载行情详情",
  "priceChannel.temporaryCard": "浏览器临时趋势卡片 {id}",
  "priceChannel.temporaryHint":
    "该卡片仅用于本地Demo演示，不代表正式发布行情。",
  "priceChannel.cardSpecification": "卡片与标准规格",
  "priceChannel.trendSummary": "趋势摘要",
  "priceChannel.trendSummaryHint": "展示本地演示数据的公开行情字段。",
  "priceChannel.instrumentNotFound": "未找到该行情标的",
  "priceChannel.instrumentNotFoundHint":
    "标的ID无效，或当前Demo数据中不存在该对象。",
  "priceChannel.trendNoPublishedSamples":
    "产品档案已发布，暂无可计算的趋势样本",
  "priceChannel.trendNoData": "当前趋势暂无可展示数据",
  "priceChannel.chartUnit": "趋势指数（基期=100）",
  "priceChannel.spec.technology": "产品类型",
  "priceChannel.spec.density": "单颗容量",
  "priceChannel.spec.dataWidth": "位宽",
  "priceChannel.spec.organization": "组织",
  "priceChannel.spec.die": "Die",
  "priceChannel.spec.speed": "等级",
  "priceChannel.spec.timing": "标称时序",
  "priceChannel.spec.package": "封装",
  "priceChannel.spec.dieStack": "Die Stack",
  "priceChannel.spec.voltage": "工作电压",
  "priceChannel.spec.temperature": "工作温度",
  "priceChannel.temporarySpec.cardTitle": "卡片标题",
  "priceChannel.temporarySpec.cardSpec": "卡片规格",
  "priceChannel.temporarySpec.fullPart": "完整料号",
  "priceChannel.temporarySpec.application": "应用场景",
  "priceChannel.temporarySpec.lifecycle": "生命周期",
  "priceChannel.temporarySpec.validUntil": "数据有效期",
  "priceChannel.notProvided": "未提供",
  "priceChannel.sidebar.publicProductCategories": "公开行情产品分类",
  "priceChannel.sidebar.searchBrand": "搜索品牌",
  "priceChannel.sidebar.brandInitials": "{name}首字母筛选",
  "priceChannel.sidebar.noBrands": "暂无匹配品牌",
  "priceChannel.sidebar.searchTechnicalFamily": "搜索分类技术族",
  "priceChannel.sidebar.publicCategories": "公开行情两级分类",
  "priceChannel.sidebar.subcategories": "{name}细分类",
  "priceChannel.sidebar.noTechnicalFamilies": "暂无匹配技术族",
  "priceChannel.operations.title": "产品与料号人工审核",
  "priceChannel.operations.pendingCount": "{count} 项待处理",
  "priceChannel.operations.filter": "运营审核对象筛选",
  "priceChannel.operations.tab.ALL": "全部",
  "priceChannel.operations.tab.PRODUCT_FACT": "产品事实",
  "priceChannel.operations.tab.PART_NUMBER": "标准料号",
  "priceChannel.operations.tab.INVENTORY_BATCH": "库存批组",
  "priceChannel.operations.tab.QUOTE_OBSERVATION": "报价观察",
  "priceChannel.operations.tab.ENGINEERING_RETURN": "工程退回",
  "priceChannel.operations.publicProfile": "公开产品档案补充",
  "priceChannel.operations.completeProfile": "补齐分类详情页必需信息",
  "priceChannel.operations.autofill": "一键补充",
  "priceChannel.operations.profileBoundary":
    "这里不填写料号、库存和报价；它们由后续“料号上报”独立维护。",
  "priceChannel.operations.brandDisplayName": "品牌展示名称",
  "priceChannel.operations.subcategory": "产品细分",
  "priceChannel.operations.lifecycle": "生命周期",
  "priceChannel.operations.summary": "产品说明",
  "priceChannel.operations.saveProfile": "保存补充资料",
  "priceChannel.operations.saveBeforeApprove":
    "全部必填资料保存后，才允许“通过”并进入公开分类。",
  "priceChannel.operations.opinionPlaceholder":
    "通过、退回或拒绝都必须说明理由",
  "priceChannel.operations.startReview": "开始审核",
  "priceChannel.operations.requestChanges": "退回补充",
  "priceChannel.operations.noMatching": "当前筛选范围没有待审核对象",
  "priceChannel.operations.productFolder": "产品文件夹",
  "priceChannel.operations.partIntake": "料号进件",
  "priceChannel.operations.reviewStarted": "已开始审核产品资料",
  "priceChannel.operations.autofillReady":
    "已生成一组公开产品档案Demo资料，再次点击可切换",
  "priceChannel.operations.profileSaved": "公开产品档案已保存",
  "priceChannel.operations.profileForbidden":
    "当前身份不能补充该产品的公开档案",
  "priceChannel.operations.profileIncomplete": "公开产品档案尚未补齐",
  "priceChannel.operations.opinionRequired": "请先填写审核意见",
  "priceChannel.operations.opinionTooLong": "审核意见最多输入25个字符",
  "priceChannel.operations.notPublishable": "当前记录尚未满足发布条件",
  "priceChannel.operations.reviewUnavailable": "当前记录无法审核",
  "priceChannel.operations.approved": "运营审核通过，Demo 数据已发布",
  "priceChannel.operations.saved": "运营审核结果已保存",
  "priceChannel.catalog.draftChanged": "产品草稿状态已变化，请刷新后重试",
  "priceChannel.messages.visibleSubmissions": "{count} 项可见申报",
  "priceChannel.messages.ready": "可立即处理",
  "priceChannel.messages.workflow.certification-review.title": "待审核企业认证",
  "priceChannel.messages.workflow.certification-review.detail":
    "品牌方和平台商提交后统一进入运营部审核",
  "priceChannel.messages.workflow.operations-review.title": "待处理运营审核",
  "priceChannel.messages.workflow.operations-review.detail":
    "产品事实与料号、库存批组、报价统一在同一工作区审核",
  "priceChannel.messages.workflow.part-number-submit.title": "料号上报",
  "priceChannel.messages.workflow.part-number-submit.detail":
    "在已有或新建产品下新增料号、跟进库存批组与报价",
  "priceChannel.messages.workflow.product-submit.title": "产品上报",
  "priceChannel.messages.workflow.product-submit.detail":
    "只建立产品基础档案，不夹带料号、库存或报价",
  "priceChannel.quote.folderHint": "产品文件夹下的料号、库存与报价",
  "priceChannel.quote.headingStatus": "业务提交 · 运营审核后发布",
  "priceChannel.quote.combineObject": "组合报价对象",
  "priceChannel.quote.chooseProduct": "选择产品",
  "priceChannel.quote.channel": "报价渠道",
  "priceChannel.quote.chooseSource": "选择报价来源",
  "priceChannel.quote.partMode": "料号操作方式",
  "priceChannel.quote.followPart": "跟进料号",
  "priceChannel.quote.newPart": "新增料号",
  "priceChannel.quote.chooseExistingPart": "选择现有料号",
  "priceChannel.quote.newPartHint": "生成进件时自动创建不冲突的新料号",
  "priceChannel.quote.batchMode": "库存批次操作方式",
  "priceChannel.quote.followBatch": "跟进批次",
  "priceChannel.quote.newBatch": "新增批次",
  "priceChannel.quote.chooseExistingBatch": "选择现有批次",
  "priceChannel.quote.newBatchHint": "生成进件时创建新的库存批次",
  "priceChannel.quote.regenerate": "换一组报价资料",
  "priceChannel.quote.generate": "生成本次报价进件",
  "priceChannel.quote.currentCombination": "当前组合",
  "priceChannel.quote.channelShort": "渠道",
  "priceChannel.quote.batchShort": "批次",
  "priceChannel.quote.batchHistory": "批次报价历史",
  "priceChannel.quote.noPublishedQuotes": "当前库存批次还没有已发布报价",
  "priceChannel.quote.intakeAndAi": "本次进件与 AI 预解析",
  "priceChannel.quote.rawIntake": "原始报价进件",
  "priceChannel.quote.time": "报价时间",
  "priceChannel.quote.stockMoq": "库存 / MOQ",
  "priceChannel.quote.tierPrices": "阶梯价",
  "priceChannel.quote.tiers": "{count} 档",
  "priceChannel.quote.aiPreparse": "AI 预解析",
  "priceChannel.quote.demoCandidate": "演示候选",
  "priceChannel.quote.correctedValue": "{name}修正值",
  "priceChannel.quote.regenerateCandidate": "{name}重新生成候选值",
  "priceChannel.quote.currentDecision": "{name}当前状态为{status}",
  "priceChannel.quote.cycleDecision": "{name}切换确认、修正或重置",
  "priceChannel.quote.stableMapping": "稳定映射",
  "priceChannel.quote.confirmUpload": "确认上传并交付运营部",
  "priceChannel.quote.notGenerated": "尚未生成本次进件",
  "priceChannel.quote.generateHint":
    "先在左侧确定组合，再生成报价与 AI 预解析结果。",
  "priceChannel.quote.decision.ACCEPTED": "确认",
  "priceChannel.quote.decision.CORRECTED": "修正",
  "priceChannel.quote.decision.REGENERATED": "重置",
  "priceChannel.quote.notSelected": "尚未选择",
  "priceChannel.quote.autoGenerate": "将自动生成",
  "priceChannel.quote.withNewBatch": "随新批次生成",
  "priceChannel.quote.generated": "已按当前组合生成本次报价和 AI 预解析结果",
  "priceChannel.quote.correctedRequired": "{name}修正值不能为空",
  "priceChannel.quote.timePending": "时间待补充",
  "priceChannel.quote.quantityUnknown": "数量未知",
  "priceChannel.quote.confirmFields": "请完成AI字段确认",
  "priceChannel.quote.sourceForbidden": "当前身份无权提交该渠道来源",
  "priceChannel.quote.submitted": "上传确认快照已保存，已进入运营审核队列",
  "priceChannel.brandArchive": "品牌档案",
  "priceChannel.brandCounts": "{categories} 个经营分类 · {products} 个相关产品",
  "priceChannel.regionalMarketCaveat":
    "按当前报价来源归属重算，不代表当地成交价格；各分类独立统计。",
  "priceChannel.marketObservation": "市场观察",
  "priceChannel.brandMarketLevel": "{level}级品牌行情",
  "priceChannel.productRelated": "产品相关",
  "priceChannel.openMarketArchive": "查看{name}行情档案",
  "priceChannel.sevenDayCompositeSparkline": "{name}近7日综合趋势缩略图",
  "priceChannel.sevenDayMarketSparkline": "{name}近7日行情趋势缩略图",
  "priceChannel.defaultMarketSparkline": "近7日行情趋势缩略图",
  "priceChannel.demo": "演示",
  "priceChannel.approvedProductCount": "{count} 个已审核产品",
  "priceChannel.coverageCounts": "{categories} 个分类 · {products} 个产品",
  "priceChannel.related.parent": "上位相关",
  "priceChannel.related.peer": "同级相关",
  "priceChannel.related.child": "下位相关",
  "priceChannel.related.peerAndParent": "同级与上位相关",
  "priceChannel.spotBoard.title": "当前产品总类行情标的大盘",
  "priceChannel.spotBoard.favorite": "收藏",
  "priceChannel.spotBoard.model": "产品型号",
  "priceChannel.spotBoard.index": "指数",
  "priceChannel.spotBoard.sevenDay": "近7日",
  "priceChannel.spotBoard.recentRange": "近7点指数高 / 低",
  "priceChannel.spotBoard.samplesSources": "样本 / 来源",
  "priceChannel.spotBoard.trend": "走势图",
  "priceChannel.spotBoard.sourceSummary":
    "{samples}个样本，{sources}个来源，{detail}",
  "priceChannel.personal.readOnly": "当前为只读模式",
  "priceChannel.personal.viewCertification": "查看认证",
  "priceChannel.personal.timelineLabel": "提交审核发布时间线，最新节点在左侧",
  "priceChannel.personal.noTimelineEvents": "暂无已记录的提交事件",
  "priceChannel.personal.noEventTime": "未记录时间",
  "priceChannel.personal.messageDescription":
    "行情更新、料号库存、业务事项与系统通知均按当前模拟账号独立汇总。",
  "priceChannel.personal.filter.ALL": "全部",
  "priceChannel.personal.filter.UNREAD": "未读",
  "priceChannel.personal.messageCategories": "消息分类",
  "priceChannel.personal.category.ALL": "全部",
  "priceChannel.personal.category.MARKET": "行情关注",
  "priceChannel.personal.category.INVENTORY": "料号 / 库存",
  "priceChannel.personal.category.WORKFLOW": "业务流程",
  "priceChannel.personal.category.SYSTEM": "系统",
  "priceChannel.personal.businessItems": "业务事项",
  "priceChannel.personal.openRelated": "打开关联对象",
  "priceChannel.personal.markRead": "标记已读",
  "priceChannel.personal.noMessages": "暂无符合条件的消息",
  "priceChannel.personal.submissionHistory": "提交历史",
  "priceChannel.personal.coreSpecs": "核心规格",
  "priceChannel.personal.collapseDetails": "收起详细信息",
  "priceChannel.personal.expandDetails": "展开详细信息",
  "priceChannel.personal.initialDraftTime": "初稿时间：{time}",
  "priceChannel.personal.formalSubmit": "正式提交",
  "priceChannel.personal.noVisibleSubmissions": "暂无可见申报",
  "priceChannel.personal.submissionHint":
    "提交产品或料号资料后，运营审核状态会显示在这里。",
  "priceChannel.personal.productBasicProfile": "产品基础档案",
  "priceChannel.personal.moreSpecs": "{values} 等",
  "priceChannel.personal.productReadOnly":
    "当前身份或企业认证不允许创建产品申报。",
  "priceChannel.personal.autofillV5": "一键填报第五版示例",
  "priceChannel.personal.productDisplayName": "产品展示名称",
  "priceChannel.personal.stableBrand": "稳定品牌",
  "priceChannel.personal.technicalDimensions": "技术维度",
  "priceChannel.personal.v5Dimensions": "第五版产品维度",
  "priceChannel.personal.reset": "重置",
  "priceChannel.personal.submitToOperations": "正式提交运营审核",
  "priceChannel.personal.nameRequired": "请输入产品展示名称",
  "priceChannel.personal.categoryRequired": "请选择一级分类",
  "priceChannel.personal.brandRequired": "请选择稳定品牌",
  "priceChannel.personal.dimensionRequired": "请选择{name}",
  "priceChannel.statusTag.UNVERIFIED": "未认证",
  "priceChannel.statusTag.DRAFT": "草稿",
  "priceChannel.statusTag.SUBMITTED": "已提交",
  "priceChannel.statusTag.UNDER_REVIEW": "审核中",
  "priceChannel.statusTag.DEPARTMENT_APPROVED": "待领导终审",
  "priceChannel.statusTag.CHANGES_REQUESTED": "退回补充",
  "priceChannel.statusTag.REJECTED": "未通过",
  "priceChannel.statusTag.APPROVED": "已通过",
  "priceChannel.statusTag.PUBLISHED": "已发布",
  "priceChannel.statusTag.EXPIRED": "已过期",
  "priceChannel.statusTag.REVOKED": "已撤销",
  "priceChannel.profile.title": "企业资料",
  "priceChannel.profile.hint": "展示企业主体、经营能力和联系人。",
  "priceChannel.profile.preview": "预览公开档案",
  "priceChannel.profile.summary": "企业档案摘要",
  "priceChannel.profile.completeness": "资料完整度",
  "priceChannel.profile.completenessHint": "按必填分组计算",
  "priceChannel.profile.status": "档案状态",
  "priceChannel.profile.statusHint": "状态不由保存动作提升",
  "priceChannel.profile.approvedQualifications": "有效资质",
  "priceChannel.profile.qualificationHint": "完整版本进入资料库",
  "priceChannel.profile.organization": "企业主体",
  "priceChannel.profile.displayName": "企业展示名",
  "priceChannel.profile.shortName": "企业简称",
  "priceChannel.profile.region": "所属地区",
  "priceChannel.profile.supplierCode": "供应商Demo编码",
  "priceChannel.profile.organizationId": "组织ID",
  "priceChannel.profile.parentOrganization": "主/子组织关系",
  "priceChannel.profile.description": "企业简介",
  "priceChannel.profile.capabilities": "经营能力",
  "priceChannel.profile.productFamilies": "产品族",
  "priceChannel.profile.brandManufacturers": "品牌/原厂",
  "priceChannel.profile.applications": "应用领域",
  "priceChannel.profile.supplyRegions": "供货地区",
  "priceChannel.profile.commonMoq": "常见MOQ",
  "priceChannel.profile.leadTime": "常见交期",
  "priceChannel.profile.stockConditions": "货况口径",
  "priceChannel.profile.contacts": "联系方式",
  "priceChannel.profile.defaultContact": "默认",
  "priceChannel.profile.materialSummary": "认证材料摘要",
  "priceChannel.profile.openLibrary": "打开资料库",
  "priceChannel.profile.savedLocally": "当前页面草稿已保存，未写入后端。",
  "priceChannel.profile.saveDraft": "保存本地草稿",
  "priceChannel.profile.readOnly": "当前身份只读",
  "priceChannel.profile.noOrganization": "当前身份没有可用的企业组织范围",
  "priceChannel.profile.publicPreview": "企业公开档案预览",
  "priceChannel.profile.publicPreviewHint":
    "只显示已批准、已发布且明确公开的字段。",
  "priceChannel.profile.backToProfile": "返回企业资料",
  "priceChannel.profile.publicProfile": "公开企业档案",
  "priceChannel.profile.brands": "覆盖品牌",
  "priceChannel.profile.notPublic": "档案尚未批准并公开",
  "priceChannel.qualification.title": "资质资料",
  "priceChannel.qualification.hint":
    "附件仅保存脱敏元数据；版本替换不会覆盖历史记录。",
  "priceChannel.qualification.type": "资料类型",
  "priceChannel.qualification.allTypes": "全部类型",
  "priceChannel.qualification.reviewStatus": "审核状态",
  "priceChannel.qualification.allStatuses": "全部状态",
  "priceChannel.qualification.versions": "资料版本",
  "priceChannel.qualification.count": "{count} 条",
  "priceChannel.qualification.effectivePeriod": "有效期",
  "priceChannel.qualification.selectedAt": "选择时间",
  "priceChannel.qualification.linkedProducts": "关联产品",
  "priceChannel.qualification.noLinkedProducts": "未关联产品",
  "priceChannel.qualification.replacedVersion": "替换版本",
  "priceChannel.qualification.firstVersion": "首个版本",
  "priceChannel.qualification.latestReturn": "最近退回：",
  "priceChannel.qualification.empty": "当前筛选条件下没有资质资料",
  "priceChannel.qualification.createVersion": "创建新版本草稿",
  "priceChannel.qualification.selectAttachment": "选择演示附件",
  "priceChannel.qualification.noExtension": "无扩展名",
  "priceChannel.qualification.noFile": "尚未选择文件；不会读取附件内容。",
  "priceChannel.qualification.readOnly": "当前身份只读，不能创建资料版本。",
  "priceChannel.qualification.saveDraft": "保存为新版本草稿",
  "priceChannel.qualification.saved": "资质新版本已创建为共享草稿。",
  "priceChannel.certCenter.title": "企业认证",
  "priceChannel.certCenter.hint":
    "企业主体、品牌或授权范围审核采用部门审核与领导终审两阶段。",
  "priceChannel.certCenter.resetDemo": "重置认证Demo",
  "priceChannel.certCenter.leaderReview": "企业认证进度与终审",
  "priceChannel.certCenter.departmentReview": "企业认证部门审核",
  "priceChannel.certCenter.noReview": "当前没有待审核企业认证。",
  "priceChannel.certCenter.currentSubject": "当前认证主体",
  "priceChannel.certCenter.legalName": "企业法定名称",
  "priceChannel.certCenter.creditCode": "统一社会信用代码",
  "priceChannel.certCenter.contact": "联系人",
  "priceChannel.certCenter.validUntil": "有效期",
  "priceChannel.certCenter.scope": "认证范围",
  "priceChannel.certCenter.applicationProgress": "认证申请进度",
  "priceChannel.certCenter.applicationMaterials": "本次申请资料",
  "priceChannel.certCenter.noCertification": "当前组织尚未建立企业认证资料",
  "priceChannel.certCenter.start": "开始认证",
  "priceChannel.certCenter.notApplicable": "当前身份不适用企业认证",
  "priceChannel.certCenter.roleHint":
    "{role}使用内部组织授权或公开只读范围，不创建外部企业认证。企业认证仅面向自有品牌和授权平台商。",
  "priceChannel.certCenter.demoDisclaimer":
    "本页全部企业、材料、状态、审核和有效期均为浏览器本地Demo，不构成真实企业认证、授权或资质背书。",
  "priceChannel.certCenter.registeredAddress": "注册地址",
  "priceChannel.certCenter.website": "企业官网",
  "priceChannel.certCenter.notProvided": "未填写",
  "priceChannel.certCenter.contactPhone": "联系电话",
  "priceChannel.certCenter.contactEmail": "联系邮箱",
  "priceChannel.certCenter.evidence": "证明材料",
  "priceChannel.certCenter.productCategories": "产品类别",
  "priceChannel.certCenter.brands": "品牌",
  "priceChannel.certCenter.businessRegions": "业务区域",
  "priceChannel.certCenter.priceTypes": "价格类型",
  "priceChannel.certCenter.businessDescription": "业务与数据来源说明",
  "priceChannel.certMaterials.subject": "企业主体",
  "priceChannel.certMaterials.type": "企业类型",
  "priceChannel.certMaterials.type.SELF_OWNED_BRAND": "自有品牌",
  "priceChannel.certMaterials.type.AUTHORIZED_PLATFORM": "授权平台商",
  "priceChannel.certMaterials.organizationId": "组织ID",
  "priceChannel.certMaterials.contactSection": "联系人与业务说明",
  "priceChannel.certMaterials.businessDescription": "业务说明",
  "priceChannel.certMaterials.scope": "申报业务范围",
  "priceChannel.certMaterials.evidenceCount": "证明材料（{count} 份）",
  "priceChannel.certMaterials.evidenceType": "材料类型：",
  "priceChannel.certMaterials.evidenceId": "Evidence ID：",
  "priceChannel.certMaterials.demoDigest": "Demo摘要：",
  "priceChannel.certMaterials.noEvidence": "未提交证明材料。",
  "priceChannel.certMaterials.reviewTrace": "提交与审核轨迹",
  "priceChannel.certMaterials.certificationId": "认证编号",
  "priceChannel.certMaterials.source": "数据来源",
  "priceChannel.certMaterials.submittedAt": "提交时间",
  "priceChannel.certMaterials.updatedAt": "最近更新",
  "priceChannel.certMaterials.departmentReview": "运营部审核",
  "priceChannel.certMaterials.departmentOpinion": "运营部意见",
  "priceChannel.certMaterials.leaderReview": "领导终审",
  "priceChannel.certMaterials.leaderOpinion": "领导意见",
  "priceChannel.certMaterials.validFrom": "认证生效",
  "priceChannel.certMaterials.notFilled": "未填写",
  "priceChannel.certMaterials.notOccurred": "尚未发生",
  "priceChannel.certMaterials.listSeparator": "、",
  "priceChannel.certMaterials.fixture": "冻结Fixture",
  "priceChannel.certMaterials.browserJson": "浏览器临时JSON",
  "priceChannel.certMaterials.evidence.BUSINESS_LICENSE": "营业执照",
  "priceChannel.certMaterials.evidence.BRAND_OWNERSHIP": "品牌权属材料",
  "priceChannel.certMaterials.evidence.CHANNEL_AUTHORIZATION": "渠道授权材料",
  "priceChannel.certMaterials.evidence.OTHER": "其他证明材料",
  "priceChannel.certMaterials.evidenceStatus.PENDING": "待校验",
  "priceChannel.certMaterials.evidenceStatus.NEEDS_REVIEW": "待人工复核",
  "priceChannel.certMaterials.evidenceStatus.ACCEPTED": "已接受",
  "priceChannel.certMaterials.evidenceStatus.REJECTED": "已拒绝",
  "priceChannel.certMaterials.status.UNVERIFIED": "演示未认证",
  "priceChannel.certMaterials.status.DRAFT": "资料待提交",
  "priceChannel.certMaterials.status.SUBMITTED": "已提交",
  "priceChannel.certMaterials.status.UNDER_REVIEW": "部门审核中",
  "priceChannel.certMaterials.status.DEPARTMENT_APPROVED": "部门已通过",
  "priceChannel.certMaterials.status.CHANGES_REQUESTED": "待补资料",
  "priceChannel.certMaterials.status.APPROVED": "演示已认证",
  "priceChannel.certMaterials.status.REJECTED": "演示未通过",
  "priceChannel.certMaterials.status.SUSPENDED": "演示已停用",
  "priceChannel.certMaterials.status.EXPIRED": "演示已过期",
  "priceChannel.certTimeline.aria": "认证审核执行流程",
  "priceChannel.certTimeline.opinion": "审核意见：{opinion}",
  "priceChannel.certTimeline.stage.submitter": "申请方提交",
  "priceChannel.certTimeline.stage.operations": "运营部审核",
  "priceChannel.certTimeline.stage.leader": "领导终审",
  "priceChannel.certTimeline.stageExtra": "审核阶段{number}",
  "priceChannel.submissionDetail.title": "提交详情",
  "priceChannel.submissionDetail.unknown": "未知提交",
  "priceChannel.submissionDetail.back": "返回申报进度",
  "priceChannel.submissionDetail.version": "版本 {version}",
  "priceChannel.submissionDetail.productName": "产品名称",
  "priceChannel.submissionDetail.fullPartNumber": "完整料号",
  "priceChannel.submissionDetail.normalizedPartNumber": "规范料号",
  "priceChannel.submissionDetail.dimensions": "第五版维度",
  "priceChannel.submissionDetail.reviewTimeline": "审核时间线",
  "priceChannel.submissionDetail.notFound": "提交不存在或超出当前对象范围",
  "priceChannel.eventTimeline.empty": "暂无状态事件",
  "priceChannel.rangeMore.more": "更多",
  "priceChannel.rangeMore.aria": "自定义行情指数范围",
  "priceChannel.rangeMore.timezone": "时间按北京时间（UTC+8）填写",
  "priceChannel.rangeMore.invalid": "时间范围无效或超出当前发布版本的范围",
  "priceChannel.legacySurface.company": "本企业资料",
  "priceChannel.legacySurface.qualifications": "认证材料",
  "priceChannel.legacySurface.company-preview": "企业公开档案",
  "priceChannel.legacySurface.unavailable":
    "此入口已保留，但正式企业资料、资质库与公开档案接口尚未接通；这里不会显示演示数据。",
  "priceChannel.legacySurface.certifications": "查看已接通的企业认证",
  "priceChannel.rangeMore.start": "开始时间",
  "priceChannel.rangeMore.end": "结束时间",
  "priceChannel.rangeMore.granularity": "粒度",
  "priceChannel.rangeMore.minute": "分钟",
  "priceChannel.rangeMore.hour": "小时",
  "priceChannel.rangeMore.day": "日",
  "priceChannel.rangeMore.week": "周",
  "priceChannel.rangeMore.month": "月",
  "priceChannel.rangeMore.step": "间隔",
  "priceChannel.rangeMore.hint": "分钟级仅用于Demo采样，最多展示90个点。",
  "priceChannel.rangeMore.apply": "应用范围",
  "priceChannel.record.quoteObject": "组合报价对象",
  "priceChannel.record.quoteChannel": "报价渠道",
  "priceChannel.record.inventoryBatch": "库存批次",
  "priceChannel.record.currentCombination": "当前组合",
  "priceChannel.record.latestQuote": "最新报价",
  "priceChannel.record.quoteTime": "报价时间",
  "priceChannel.record.inventoryMoq": "库存 / MOQ",
  "priceChannel.record.packageCondition": "包装 / 货况",
  "priceChannel.record.tierCount": "{count} 档",
  "priceChannel.record.batchHistory": "批次报价历史",
  "priceChannel.record.noBatchHistory": "当前库存批次还没有已发布报价",
  "priceChannel.record.intakeAndAi": "本次进件与 AI 预解析",
  "priceChannel.record.primaryCategory": "一级分类",
  "priceChannel.record.technologyFamily": "技术族",
  "priceChannel.record.uploaderConfirmation": "上传方确认",
  "priceChannel.record.confirmedAt": "确认时间",
  "priceChannel.record.channelPartMapping": "渠道料号映射",
  "priceChannel.record.noAiResult": "本次进件尚未保存 AI 预解析结果",
  "priceChannel.record.productIdentity": "产品身份",
  "priceChannel.record.productDescription": "产品说明",
  "priceChannel.record.noProductFacts": "该历史记录未保存产品基础资料",
  "priceChannel.record.unlinkedProduct": "待关联产品",
  "priceChannel.record.pendingGeneration": "待生成",
  "priceChannel.record.unlinkedChannel": "待关联渠道",
  "priceChannel.record.pendingRecognition": "待识别",
  "priceChannel.record.confirmed": "已确认",
  "priceChannel.record.reconfirm": "需重新确认",
  "priceChannel.record.pendingMapping": "待建立",
  "priceChannel.record.mapped": "已建立",
  "priceChannel.record.pendingReview": "待复核",
  "priceChannel.dimensionTrackAria": "行情维度轨道",
  "priceChannel.certReview.collapse": "收起",
  "priceChannel.certReview.expand": "展开",
  "priceChannel.certReview.disclosureAria": "{action}{name}企业认证资料",
  "priceChannel.certReview.materialsAria": "{name}企业认证资料",
  "priceChannel.certReview.waitingForOperations":
    "运营部审核中：领导可展开查看全部资料，暂不能终审。",
  "priceChannel.certReview.readyForFinal":
    "运营部已通过：现在可以执行领导终审。",
  "priceChannel.certReview.opinion": "审核意见",
  "priceChannel.certReview.opinionAria": "{name}审核意见",
  "priceChannel.certReview.waitingPlaceholder": "等待运营部完成审核",
  "priceChannel.certReview.reasonPlaceholder": "通过、退回或拒绝都必须说明理由",
  "priceChannel.certReview.disabledTitle": "等待运营部审核通过后开放",
  "priceChannel.certReview.finalApprove": "终审通过",
  "priceChannel.certReview.departmentApprove": "部门通过",
  "priceChannel.certReview.returnMaterials": "退回补件",
  "priceChannel.certReview.notProvided": "未填写",
  "priceChannel.certReview.opinionRequired": "请先填写审核意见",
  "priceChannel.account.currentIdentity": "价格频道当前身份",
  "priceChannel.account.openMessages": "打开消息中心",
  "priceChannel.account.messages": "消息中心",
  "priceChannel.account.debugAccount": "调试账号",
  "priceChannel.account.selectRoleGroup": "选择角色类别",
  "priceChannel.account.selectDepartment": "选择公司部门",
  "priceChannel.account.switchMember": "切换当前成员",
  "priceChannel.account.selectIdentity": "选择当前业务身份",
  "priceChannel.api.localTargetRequired":
    "请先配置 VUE_APP_MTS_API_TARGET 指向本地 Spring Boot 服务",
  "priceChannel.api.requestFailed": "价格频道请求失败，请稍后重试",
  "priceChannel.api.unknownReviewAction": "未知审核动作",
  "priceChannel.api.error.UNAUTHENTICATED": "请先登录",
  "priceChannel.api.error.FORBIDDEN": "当前身份无此操作权限",
  "priceChannel.api.error.NOT_FOUND": "请求的内容不存在",
  "priceChannel.api.error.RELEASE_EXPIRED":
    "行情版本已过期，请刷新查看最新版本",
  "priceChannel.api.error.INVALID_ARGUMENT": "请求参数无效",
  "priceChannel.api.error.VERSION_CONFLICT": "版本已变化，请刷新后重试",
  "priceChannel.api.error.IDEMPOTENCY_CONFLICT": "相同请求标识对应的内容已变化",
  "priceChannel.api.error.PRICE_CHANNEL_UNAVAILABLE": "价格频道暂不可用",
});

// 共用行情组件
export const sharedComponents = Object.freeze({
  "marketComponents.search": "搜索",
  "marketComponents.searchPlaceholder": "请输入搜索内容",
  "marketComponents.viewProduct": "查看商品：{title}",
  "marketComponents.unnamedProduct": "未命名商品",
  "marketComponents.productImage": "商品图片",
  "marketComponents.featured": "精选",
  "marketComponents.buy": "求",
  "marketComponents.brand": "品牌",
  "marketComponents.partNumber": "料号",
  "marketComponents.type": "类型",
  "marketComponents.capacity": "容量",
  "marketComponents.architecture": "架构",
  "marketComponents.speed": "速率",
  "marketComponents.ballCount": "球位",
  "marketComponents.price": "价格",
  "marketComponents.quantity": "数量",
  "marketComponents.publisher": "发布人",
  "marketComponents.priceOnRequest": "价格面议",
  "marketComponents.totalAmount": "总金额 ¥{amount}",
  "marketComponents.payCommission": "支付佣金",
  "marketComponents.requestCancel": "申请取消",
  "marketComponents.confirmReceipt": "确认收货",
  "marketComponents.review": "评价",
  "marketComponents.currencyUnit": "货币单位",
  "marketComponents.chooseCurrencyUnit": "选择价格货币单位",
  "marketComponents.usDollar": "美元",
  "marketComponents.yuan": "人民币",
});

export const messages = Object.freeze({
  ...businessDisplay,
  ...market,
  ...sharedComponents,
});

// 系统技术分类显示名；不修改原始分类与查询标识
export const catalogLabels = Object.freeze({
  晶圆: "晶圆",
  IC芯片: "IC芯片",
  模组成品: "模组成品",
  技术族: "技术族",
  类型: "类型",
  制程: "制程",
  代际: "代际",
  容量: "容量",
  频率: "频率",
  速率: "速率",
  位宽: "位宽",
  组织: "组织",
  层数: "层数",
  直径: "直径",
  封装: "封装",
  结构: "结构",
  协议: "协议",
  接口: "接口",
  形态: "形态",
  等级: "等级",
  闪存晶圆: "闪存晶圆",
  内存晶圆: "内存晶圆",
  闪存芯片: "闪存芯片",
  内存芯片: "内存芯片",
  嵌入式存储: "嵌入式存储",
  嵌入式存储器: "嵌入式存储器",
  固态硬盘: "固态硬盘",
  内存条: "内存条",
  存储卡: "存储卡",
  闪存卡: "闪存卡",
  U盘: "U盘",
  USB闪存盘: "USB闪存盘",
  闪存盘: "闪存盘",
  其他SSD: "其他SSD",
  消费级: "消费级",
  企业级: "企业级",
  工业级: "工业级",
  二级市场: "二级市场",
  高速: "高速",
  不适用: "不适用",
  "2.5英寸": "2.5英寸",
  裸Die: "裸Die",
  封装颗粒: "封装颗粒",
  单Die: "单Die",
  多Die: "多Die",
  管理封装: "管理封装",
  TSV堆叠: "TSV堆叠",
  USB大容量存储: "USB大容量存储",
});

// 冻结目录的机器代码显示名
export const catalogCodes = Object.freeze({
  "flash-wafer": "闪存晶圆",
  "memory-wafer": "内存晶圆",
  "flash-chip": "闪存芯片",
  "memory-chip": "内存芯片",
  "memory-module": "内存条",
  "solid-state-drive": "固态硬盘",
  "flash-card": "闪存卡",
  "embedded-storage": "嵌入式存储器",
  "usb-flash-drive": "USB闪存盘",
  ymtc: "YMTC 长江存储",
  "protocol-version": "协议",
  "speed-class": "等级",
  "form-factor": "形态",
  "byte-capacity-gbyte": "容量",
  "interface-generation": "接口",
  "ecc-capability": "ECC",
  "flash-cell-type": "制程",
  "wafer-device-kind": "类型",
  "flash-memory-kind": "类型",
  "dram-generation": "代际",
  "bit-density-gbit": "容量",
  "clock-mhz": "频率",
  "data-rate-mtps": "速率",
  "bus-width": "位宽",
  organization: "组织",
  "stack-layer-count": "层数",
  "wafer-diameter-mm": "直径",
  "interface-rate-mtps": "速率",
  package: "封装",
  "package-structure": "结构",
  rank: "Rank",
  nvme: "NVMe",
  sata: "SATA",
  emmc: "eMMC",
  emcp: "eMCP",
  slc: "SLC",
  mlc: "MLC",
  tlc: "TLC",
  qlc: "QLC",
  "not-applicable": "不适用",
  ldpc: "LDPC",
  "sata-iii": "SATA III",
  "2.5-inch": "2.5英寸",
  consumer: "消费级",
  enterprise: "企业级",
  industrial: "工业级",
  "secondary-market": "二级市场",
  "high-speed": "高速",
  "bare-die": "裸Die",
  "packaged-ic": "封装颗粒",
  "single-die": "单Die",
  "multi-die": "多Die",
  "managed-package": "管理封装",
  "tsv-stack": "TSV堆叠",
  "usb-mass-storage": "USB大容量存储",
  "unverified-white-batch": "白片方案",
  "unverified-black-batch": "黑片高风险方案",
});

// 已登记渠道展示参考译名；不是法定名称，未知企业保持原文
export const companyNames = Object.freeze({
  安庆存储通电子科技: "安庆存储通电子科技",
  安庆科储半导体: "安庆科储半导体",
  安庆芯拓电子商贸: "安庆芯拓电子商贸",
  安庆芯源电子供应链: "安庆芯源电子供应链",
  安阳存储通电子科技: "安阳存储通电子科技",
  安阳科储半导体: "安阳科储半导体",
  安阳芯拓电子商贸: "安阳芯拓电子商贸",
  安阳芯源电子供应链: "安阳芯源电子供应链",
  鞍山存储通电子科技: "鞍山存储通电子科技",
  鞍山芯拓电子商贸: "鞍山芯拓电子商贸",
  鞍山芯源电子供应链: "鞍山芯源电子供应链",
  蚌埠存储通电子科技: "蚌埠存储通电子科技",
  蚌埠科储半导体: "蚌埠科储半导体",
  蚌埠芯源电子供应链: "蚌埠芯源电子供应链",
  宝鸡存储通电子科技: "宝鸡存储通电子科技",
  宝鸡科储半导体: "宝鸡科储半导体",
  宝鸡芯拓电子商贸: "宝鸡芯拓电子商贸",
  宝鸡芯源电子供应链: "宝鸡芯源电子供应链",
  保定存储通电子科技: "保定存储通电子科技",
  保定科储半导体: "保定科储半导体",
  保定芯源电子供应链: "保定芯源电子供应链",
  北海科储半导体: "北海科储半导体",
  北海芯拓电子商贸: "北海芯拓电子商贸",
  北海芯源电子供应链: "北海芯源电子供应链",
  北京存储通电子科技: "北京存储通电子科技",
  北京华储电子供应链有限公司: "北京华储电子供应链有限公司",
  北京芯拓电子商贸: "北京芯拓电子商贸",
  北京芯源电子供应链: "北京芯源电子供应链",
  沧州存储通电子科技: "沧州存储通电子科技",
  沧州科储半导体: "沧州科储半导体",
  沧州芯拓电子商贸: "沧州芯拓电子商贸",
  沧州芯源电子供应链: "沧州芯源电子供应链",
  常德科储半导体: "常德科储半导体",
  常德芯拓电子商贸: "常德芯拓电子商贸",
  常德芯源电子供应链: "常德芯源电子供应链",
  常州存储通电子科技: "常州存储通电子科技",
  常州科储半导体: "常州科储半导体",
  常州芯拓电子商贸: "常州芯拓电子商贸",
  成都存储通电子科技: "成都存储通电子科技",
  成都科储半导体: "成都科储半导体",
  成都芯源电子供应链: "成都芯源电子供应链",
  滁州存储通电子科技: "滁州存储通电子科技",
  滁州芯拓电子商贸: "滁州芯拓电子商贸",
  滁州芯源电子供应链: "滁州芯源电子供应链",
  大连存储通电子科技: "大连存储通电子科技",
  大连科储半导体: "大连科储半导体",
  大连芯拓电子商贸: "大连芯拓电子商贸",
  丹东存储通电子科技: "丹东存储通电子科技",
  丹东科储半导体: "丹东科储半导体",
  丹东芯源电子供应链: "丹东芯源电子供应链",
  德阳存储通电子科技: "德阳存储通电子科技",
  德阳科储半导体: "德阳科储半导体",
  德阳芯拓电子商贸: "德阳芯拓电子商贸",
  德阳芯源电子供应链: "德阳芯源电子供应链",
  东莞存储通电子科技: "东莞存储通电子科技",
  东莞芯拓电子商贸: "东莞芯拓电子商贸",
  东莞芯源电子供应链: "东莞芯源电子供应链",
  佛山科储半导体: "佛山科储半导体",
  佛山芯拓电子商贸: "佛山芯拓电子商贸",
  佛山芯源电子供应链: "佛山芯源电子供应链",
  福州存储通电子科技: "福州存储通电子科技",
  福州科储半导体: "福州科储半导体",
  福州芯源电子供应链: "福州芯源电子供应链",
  赣州科储半导体: "赣州科储半导体",
  赣州芯拓电子商贸: "赣州芯拓电子商贸",
  赣州芯源电子供应链: "赣州芯源电子供应链",
  广州存储通电子科技: "广州存储通电子科技",
  广州科储半导体: "广州科储半导体",
  广州悦沈电子科技: "广州悦沈电子科技",
  桂林存储通电子科技: "桂林存储通电子科技",
  桂林芯拓电子商贸: "桂林芯拓电子商贸",
  桂林芯源电子供应链: "桂林芯源电子供应链",
  邯郸科储半导体: "邯郸科储半导体",
  邯郸芯拓电子商贸: "邯郸芯拓电子商贸",
  邯郸芯源电子供应链: "邯郸芯源电子供应链",
  汉中存储通电子科技: "汉中存储通电子科技",
  汉中芯拓电子商贸: "汉中芯拓电子商贸",
  汉中芯源电子供应链: "汉中芯源电子供应链",
  杭州存储通电子科技: "杭州存储通电子科技",
  杭州科储半导体: "杭州科储半导体",
  杭州芯源电子供应链: "杭州芯源电子供应链",
  合肥存储通电子科技: "合肥存储通电子科技",
  合肥科储半导体: "合肥科储半导体",
  合肥芯拓电子商贸: "合肥芯拓电子商贸",
  合肥芯源电子供应链: "合肥芯源电子供应链",
  衡阳存储通电子科技: "衡阳存储通电子科技",
  衡阳芯拓电子商贸: "衡阳芯拓电子商贸",
  衡阳芯源电子供应链: "衡阳芯源电子供应链",
  华秋商城: "华秋商城",
  黄石科储半导体: "黄石科储半导体",
  黄石芯拓电子商贸: "黄石芯拓电子商贸",
  黄石芯源电子供应链: "黄石芯源电子供应链",
  惠州存储通电子科技: "惠州存储通电子科技",
  惠州科储半导体: "惠州科储半导体",
  惠州芯拓电子商贸: "惠州芯拓电子商贸",
  惠州芯源电子供应链: "惠州芯源电子供应链",
  吉安科储半导体: "吉安科储半导体",
  吉安芯拓电子商贸: "吉安芯拓电子商贸",
  吉安芯源电子供应链: "吉安芯源电子供应链",
  济南存储通电子科技: "济南存储通电子科技",
  济南芯拓电子商贸: "济南芯拓电子商贸",
  济南芯源电子供应链: "济南芯源电子供应链",
  嘉兴存储通电子科技: "嘉兴存储通电子科技",
  嘉兴科储半导体: "嘉兴科储半导体",
  嘉兴芯拓电子商贸: "嘉兴芯拓电子商贸",
  嘉兴芯源电子供应链: "嘉兴芯源电子供应链",
  金华存储通电子科技: "金华存储通电子科技",
  金华科储半导体: "金华科储半导体",
  金华芯拓电子商贸: "金华芯拓电子商贸",
  锦州存储通电子科技: "锦州存储通电子科技",
  锦州科储半导体: "锦州科储半导体",
  锦州芯拓电子商贸: "锦州芯拓电子商贸",
  荆州存储通电子科技: "荆州存储通电子科技",
  荆州科储半导体: "荆州科储半导体",
  荆州芯拓电子商贸: "荆州芯拓电子商贸",
  荆州芯源电子供应链: "荆州芯源电子供应链",
  九江存储通电子科技: "九江存储通电子科技",
  九江科储半导体: "九江科储半导体",
  九江芯拓电子商贸: "九江芯拓电子商贸",
  九江芯源电子供应链: "九江芯源电子供应链",
  廊坊存储通电子科技: "廊坊存储通电子科技",
  廊坊科储半导体: "廊坊科储半导体",
  廊坊芯拓电子商贸: "廊坊芯拓电子商贸",
  乐山存储通电子科技: "乐山存储通电子科技",
  乐山科储半导体: "乐山科储半导体",
  乐山芯源电子供应链: "乐山芯源电子供应链",
  立创商城: "立创商城",
  柳州存储通电子科技: "柳州存储通电子科技",
  柳州科储半导体: "柳州科储半导体",
  柳州芯拓电子商贸: "柳州芯拓电子商贸",
  柳州芯源电子供应链: "柳州芯源电子供应链",
  龙岩存储通电子科技: "龙岩存储通电子科技",
  龙岩科储半导体: "龙岩科储半导体",
  龙岩芯拓电子商贸: "龙岩芯拓电子商贸",
  洛阳存储通电子科技: "洛阳存储通电子科技",
  洛阳科储半导体: "洛阳科储半导体",
  洛阳芯拓电子商贸: "洛阳芯拓电子商贸",
  马鞍山存储通电子科技: "马鞍山存储通电子科技",
  马鞍山科储半导体: "马鞍山科储半导体",
  马鞍山芯拓电子商贸: "马鞍山芯拓电子商贸",
  绵阳存储通电子科技: "绵阳存储通电子科技",
  绵阳科储半导体: "绵阳科储半导体",
  绵阳芯拓电子商贸: "绵阳芯拓电子商贸",
  南昌存储通电子科技: "南昌存储通电子科技",
  南昌芯拓电子商贸: "南昌芯拓电子商贸",
  南昌芯源电子供应链: "南昌芯源电子供应链",
  南充存储通电子科技: "南充存储通电子科技",
  南充科储半导体: "南充科储半导体",
  南充芯拓电子商贸: "南充芯拓电子商贸",
  南京存储通电子科技: "南京存储通电子科技",
  南京芯拓电子商贸: "南京芯拓电子商贸",
  南京芯源电子供应链: "南京芯源电子供应链",
  南宁存储通电子科技: "南宁存储通电子科技",
  南宁科储半导体: "南宁科储半导体",
  南宁芯源电子供应链: "南宁芯源电子供应链",
  南通存储通电子科技: "南通存储通电子科技",
  南通科储半导体: "南通科储半导体",
  南通芯拓电子商贸: "南通芯拓电子商贸",
  南通芯源电子供应链: "南通芯源电子供应链",
  南阳存储通电子科技: "南阳存储通电子科技",
  南阳科储半导体: "南阳科储半导体",
  南阳芯源电子供应链: "南阳芯源电子供应链",
  宁波存储通电子科技: "宁波存储通电子科技",
  宁波科储半导体: "宁波科储半导体",
  宁波芯拓电子商贸: "宁波芯拓电子商贸",
  莆田存储通电子科技: "莆田存储通电子科技",
  莆田科储半导体: "莆田科储半导体",
  莆田芯源电子供应链: "莆田芯源电子供应链",
  青岛科储半导体: "青岛科储半导体",
  青岛芯拓电子商贸: "青岛芯拓电子商贸",
  青岛芯源电子供应链: "青岛芯源电子供应链",
  泉州存储通电子科技: "泉州存储通电子科技",
  泉州芯拓电子商贸: "泉州芯拓电子商贸",
  泉州芯源电子供应链: "泉州芯源电子供应链",
  厦门存储通电子科技: "厦门存储通电子科技",
  厦门科储半导体: "厦门科储半导体",
  厦门芯拓电子商贸: "厦门芯拓电子商贸",
  厦门芯源电子供应链: "厦门芯源电子供应链",
  上海科储半导体: "上海科储半导体",
  上海芯拓电子商贸: "上海芯拓电子商贸",
  上海芯途电子科技有限公司: "上海芯途电子科技有限公司",
  上海芯源电子供应链: "上海芯源电子供应链",
  上饶存储通电子科技: "上饶存储通电子科技",
  上饶科储半导体: "上饶科储半导体",
  上饶芯拓电子商贸: "上饶芯拓电子商贸",
  绍兴存储通电子科技: "绍兴存储通电子科技",
  绍兴科储半导体: "绍兴科储半导体",
  绍兴芯源电子供应链: "绍兴芯源电子供应链",
  深圳存储通电子科技: "深圳存储通电子科技",
  深圳科储半导体: "深圳科储半导体",
  深圳芯源电子供应链: "深圳芯源电子供应链",
  沈阳存储通电子科技: "沈阳存储通电子科技",
  沈阳科储半导体: "沈阳科储半导体",
  沈阳芯源电子供应链: "沈阳芯源电子供应链",
  石家庄存储通电子科技: "石家庄存储通电子科技",
  石家庄芯拓电子商贸: "石家庄芯拓电子商贸",
  石家庄芯源电子供应链: "石家庄芯源电子供应链",
  世强硬创: "世强硬创",
  苏州科储半导体: "苏州科储半导体",
  苏州芯拓电子商贸: "苏州芯拓电子商贸",
  苏州芯源电子供应链: "苏州芯源电子供应链",
  唐山科储半导体: "唐山科储半导体",
  唐山芯拓电子商贸: "唐山芯拓电子商贸",
  唐山芯源电子供应链: "唐山芯源电子供应链",
  威海科储半导体: "威海科储半导体",
  威海芯拓电子商贸: "威海芯拓电子商贸",
  威海芯源电子供应链: "威海芯源电子供应链",
  潍坊存储通电子科技: "潍坊存储通电子科技",
  潍坊科储半导体: "潍坊科储半导体",
  潍坊芯拓电子商贸: "潍坊芯拓电子商贸",
  渭南存储通电子科技: "渭南存储通电子科技",
  渭南科储半导体: "渭南科储半导体",
  渭南芯拓电子商贸: "渭南芯拓电子商贸",
  温州存储通电子科技: "温州存储通电子科技",
  温州芯拓电子商贸: "温州芯拓电子商贸",
  温州芯源电子供应链: "温州芯源电子供应链",
  无锡存储通电子科技: "无锡存储通电子科技",
  无锡科储半导体: "无锡科储半导体",
  无锡芯源电子供应链: "无锡芯源电子供应链",
  芜湖科储半导体: "芜湖科储半导体",
  芜湖芯拓电子商贸: "芜湖芯拓电子商贸",
  芜湖芯源电子供应链: "芜湖芯源电子供应链",
  梧州存储通电子科技: "梧州存储通电子科技",
  梧州科储半导体: "梧州科储半导体",
  梧州芯拓电子商贸: "梧州芯拓电子商贸",
  武汉存储通电子科技: "武汉存储通电子科技",
  武汉科储半导体: "武汉科储半导体",
  武汉芯源电子供应链: "武汉芯源电子供应链",
  西安存储通电子科技: "西安存储通电子科技",
  西安芯拓电子商贸: "西安芯拓电子商贸",
  西安芯源电子供应链: "西安芯源电子供应链",
  咸阳存储通电子科技: "咸阳存储通电子科技",
  咸阳科储半导体: "咸阳科储半导体",
  咸阳芯源电子供应链: "咸阳芯源电子供应链",
  湘潭存储通电子科技: "湘潭存储通电子科技",
  湘潭科储半导体: "湘潭科储半导体",
  湘潭芯源电子供应链: "湘潭芯源电子供应链",
  襄阳存储通电子科技: "襄阳存储通电子科技",
  襄阳芯拓电子商贸: "襄阳芯拓电子商贸",
  襄阳芯源电子供应链: "襄阳芯源电子供应链",
  孝感存储通电子科技: "孝感存储通电子科技",
  孝感科储半导体: "孝感科储半导体",
  孝感芯拓电子商贸: "孝感芯拓电子商贸",
  新乡存储通电子科技: "新乡存储通电子科技",
  新乡芯拓电子商贸: "新乡芯拓电子商贸",
  新乡芯源电子供应链: "新乡芯源电子供应链",
  许昌科储半导体: "许昌科储半导体",
  许昌芯拓电子商贸: "许昌芯拓电子商贸",
  许昌芯源电子供应链: "许昌芯源电子供应链",
  烟台存储通电子科技: "烟台存储通电子科技",
  烟台科储半导体: "烟台科储半导体",
  烟台芯拓电子商贸: "烟台芯拓电子商贸",
  烟台芯源电子供应链: "烟台芯源电子供应链",
  扬州科储半导体: "扬州科储半导体",
  扬州芯拓电子商贸: "扬州芯拓电子商贸",
  扬州芯源电子供应链: "扬州芯源电子供应链",
  宜宾科储半导体: "宜宾科储半导体",
  宜宾芯拓电子商贸: "宜宾芯拓电子商贸",
  宜宾芯源电子供应链: "宜宾芯源电子供应链",
  宜昌存储通电子科技: "宜昌存储通电子科技",
  宜昌科储半导体: "宜昌科储半导体",
  宜昌芯拓电子商贸: "宜昌芯拓电子商贸",
  宜春存储通电子科技: "宜春存储通电子科技",
  宜春芯拓电子商贸: "宜春芯拓电子商贸",
  宜春芯源电子供应链: "宜春芯源电子供应链",
  营口存储通电子科技: "营口存储通电子科技",
  营口科储半导体: "营口科储半导体",
  营口芯拓电子商贸: "营口芯拓电子商贸",
  营口芯源电子供应链: "营口芯源电子供应链",
  榆林科储半导体: "榆林科储半导体",
  榆林芯拓电子商贸: "榆林芯拓电子商贸",
  榆林芯源电子供应链: "榆林芯源电子供应链",
  玉林存储通电子科技: "玉林存储通电子科技",
  玉林科储半导体: "玉林科储半导体",
  玉林芯源电子供应链: "玉林芯源电子供应链",
  岳阳存储通电子科技: "岳阳存储通电子科技",
  岳阳科储半导体: "岳阳科储半导体",
  岳阳芯拓电子商贸: "岳阳芯拓电子商贸",
  岳阳芯源电子供应链: "岳阳芯源电子供应链",
  云汉芯城: "云汉芯城",
  漳州科储半导体: "漳州科储半导体",
  漳州芯拓电子商贸: "漳州芯拓电子商贸",
  漳州芯源电子供应链: "漳州芯源电子供应链",
  长沙存储通电子科技: "长沙存储通电子科技",
  长沙芯拓电子商贸: "长沙芯拓电子商贸",
  长沙芯源电子供应链: "长沙芯源电子供应链",
  郑州存储通电子科技: "郑州存储通电子科技",
  郑州科储半导体: "郑州科储半导体",
  郑州芯拓电子商贸: "郑州芯拓电子商贸",
  郑州芯源电子供应链: "郑州芯源电子供应链",
  株洲科储半导体: "株洲科储半导体",
  株洲芯拓电子商贸: "株洲芯拓电子商贸",
  株洲芯源电子供应链: "株洲芯源电子供应链",
  珠海存储通电子科技: "珠海存储通电子科技",
  珠海科储半导体: "珠海科储半导体",
  珠海芯源电子供应链: "珠海芯源电子供应链",
  淄博存储通电子科技: "淄博存储通电子科技",
  淄博芯拓电子商贸: "淄博芯拓电子商贸",
  淄博芯源电子供应链: "淄博芯源电子供应链",
  XSOU专属报价: "XSOU专属报价",
});

// 已登记产品显示名；不修改料号、产品身份与风险等级
export const productNames = Object.freeze({
  "ADATA USB闪存盘 128GB": "ADATA USB闪存盘 128GB",
  "CXMT DDR4 16Gb x8 晶圆Demo": "CXMT DDR4 16Gb x8 晶圆Demo",
  "CXMT DDR4 8Gb x8 晶圆Demo": "CXMT DDR4 8Gb x8 晶圆Demo",
  "CXMT DDR5 16Gb x8 晶圆Demo": "CXMT DDR5 16Gb x8 晶圆Demo",
  "Intel 144L QLC 1Tb 晶圆Demo": "Intel 144L QLC 1Tb 晶圆Demo",
  "KIOXIA BiCS5 TLC 512Gb 晶圆Demo": "KIOXIA BiCS5 TLC 512Gb 晶圆Demo",
  "KIOXIA BiCS6 TLC 1Tb 晶圆Demo": "KIOXIA BiCS6 TLC 1Tb 晶圆Demo",
  "KIOXIA USB闪存盘 128GB": "KIOXIA USB闪存盘 128GB",
  "KIOXIA 企业级 SSD 2TB": "KIOXIA 企业级 SSD 2TB",
  "Kingston USB闪存盘 128GB": "Kingston USB闪存盘 128GB",
  "Lexar USB闪存盘 128GB": "Lexar USB闪存盘 128GB",
  "Macronix MX30 MLC 8Gb 晶圆Demo": "Macronix MX30 MLC 8Gb 晶圆Demo",
  "Micron B47R TLC 512Gb 晶圆Demo": "Micron B47R TLC 512Gb 晶圆Demo",
  "Micron B58R TLC 1Tb 晶圆Demo": "Micron B58R TLC 1Tb 晶圆Demo",
  "Micron DDR5 16Gb x8 晶圆Demo": "Micron DDR5 16Gb x8 晶圆Demo",
  "Micron DDR5 32Gb x8 晶圆Demo": "Micron DDR5 32Gb x8 晶圆Demo",
  "Micron HBM2E 8Gb x4 晶圆Demo": "Micron HBM2E 8Gb x4 晶圆Demo",
  "Micron LPDDR5 16Gb x16 晶圆Demo": "Micron LPDDR5 16Gb x16 晶圆Demo",
  "Micron 企业级 SSD 2TB": "Micron 企业级 SSD 2TB",
  "Nanya DDR4 8Gb x8 晶圆Demo": "Nanya DDR4 8Gb x8 晶圆Demo",
  "Nanya DDR5 16Gb x8 晶圆Demo": "Nanya DDR5 16Gb x8 晶圆Demo",
  "Netac USB闪存盘 128GB": "Netac USB闪存盘 128GB",
  "PNY USB闪存盘 128GB": "PNY USB闪存盘 128GB",
  "SK hynix DDR5 16Gb x8 晶圆Demo": "SK hynix DDR5 16Gb x8 晶圆Demo",
  "SK hynix DDR5 24Gb x8 晶圆Demo": "SK hynix DDR5 24Gb x8 晶圆Demo",
  "SK hynix HBM3 16Gb x4 晶圆Demo": "SK hynix HBM3 16Gb x4 晶圆Demo",
  "SK hynix V7 TLC 512Gb 晶圆Demo": "SK hynix V7 TLC 512Gb 晶圆Demo",
  "SK hynix V8 QLC 1Tb 晶圆Demo": "SK hynix V8 QLC 1Tb 晶圆Demo",
  "Samsung DDR5 16Gb x8 晶圆Demo": "Samsung DDR5 16Gb x8 晶圆Demo",
  "Samsung DDR5 24Gb x8 晶圆Demo": "Samsung DDR5 24Gb x8 晶圆Demo",
  "Samsung HBM3E 24Gb x4 晶圆Demo": "Samsung HBM3E 24Gb x4 晶圆Demo",
  "Samsung LPDDR5 16Gb x16 晶圆Demo": "Samsung LPDDR5 16Gb x16 晶圆Demo",
  "Samsung USB闪存盘 128GB": "Samsung USB闪存盘 128GB",
  "Samsung V6 TLC 512Gb 晶圆Demo": "Samsung V6 TLC 512Gb 晶圆Demo",
  "Samsung V7 TLC 512Gb 晶圆Demo": "Samsung V7 TLC 512Gb 晶圆Demo",
  "Samsung V8 TLC 1Tb 晶圆Demo": "Samsung V8 TLC 1Tb 晶圆Demo",
  "Samsung 企业级 SSD 2TB": "Samsung 企业级 SSD 2TB",
  "SanDisk BiCS5 TLC 512Gb 晶圆Demo": "SanDisk BiCS5 TLC 512Gb 晶圆Demo",
  "SanDisk USB闪存盘 128GB": "SanDisk USB闪存盘 128GB",
  "Seagate 企业级 SSD 2TB": "Seagate 企业级 SSD 2TB",
  "SpecTek DDR4 8Gb x8 重构晶圆Demo": "SpecTek DDR4 8Gb x8 重构晶圆Demo",
  "SpecTek E0 TLC 256Gb 重构晶圆Demo": "SpecTek E0 TLC 256Gb 重构晶圆Demo",
  "Teclast USB闪存盘 128GB": "Teclast USB闪存盘 128GB",
  "Transcend USB闪存盘 128GB": "Transcend USB闪存盘 128GB",
  "Winbond DDR3 4Gb x16 晶圆Demo": "Winbond DDR3 4Gb x16 晶圆Demo",
  "Winbond DDR4 8Gb x16 晶圆Demo": "Winbond DDR4 8Gb x16 晶圆Demo",
  "Winbond W25N SLC 4Gb 晶圆Demo": "Winbond W25N SLC 4Gb 晶圆Demo",
  "Winbond W25Q NOR 2Gb 晶圆Demo": "Winbond W25Q NOR 2Gb 晶圆Demo",
  "YMTC X1-9050 TLC 256Gb 晶圆Demo": "YMTC X1-9050 TLC 256Gb 晶圆Demo",
  "YMTC X2-9060 TLC 512Gb 晶圆Demo": "YMTC X2-9060 TLC 512Gb 晶圆Demo",
  "YMTC X3-9060 TLC 512Gb 晶圆Demo": "YMTC X3-9060 TLC 512Gb 晶圆Demo",
  "YMTC X3-9070 TLC 1Tb 晶圆Demo": "YMTC X3-9070 TLC 1Tb 晶圆Demo",
  "白片 TLC 512Gb": "白片 TLC 512Gb",
  "白片口径 DDR4 8Gb (1Gx8)": "白片口径 DDR4 8Gb (1Gx8)",
  "白片口径 DDR4 UDIMM 16GB": "白片口径 DDR4 UDIMM 16GB",
  "白片颗粒方案 MicroSD 128GB": "白片颗粒方案 MicroSD 128GB",
  "白片颗粒方案 SATA SSD 512GB": "白片颗粒方案 SATA SSD 512GB",
  "白片颗粒方案 USB闪存盘 128GB": "白片颗粒方案 USB闪存盘 128GB",
  "白片颗粒方案 eMMC 64GB": "白片颗粒方案 eMMC 64GB",
  "黑片/回收颗粒风险 SATA SSD 512GB": "黑片/回收颗粒风险 SATA SSD 512GB",
  "黑片/回收颗粒风险 eMMC 64GB": "黑片/回收颗粒风险 eMMC 64GB",
  "黑片/打磨颗粒风险 DDR4 UDIMM 16GB": "黑片/打磨颗粒风险 DDR4 UDIMM 16GB",
  "黑片/扩容风险 MicroSD 128GB": "黑片/扩容风险 MicroSD 128GB",
  "黑片/扩容风险 USB闪存盘 128GB": "黑片/扩容风险 USB闪存盘 128GB",
  "黑片风险 DDR4 8Gb (1Gx8)": "黑片风险 DDR4 8Gb (1Gx8)",
  "黑片高风险 TLC 512Gb": "黑片高风险 TLC 512Gb",
});

// 系统地理目录显示名；不转换公司名、自由地址或数据库原文
export const regionNames = Object.freeze({
  中国: "中国",
  北京: "北京",
  上海: "上海",
  香港: "香港",
  澳门: "澳门",
  广东: "广东",
  深圳: "深圳",
  广州: "广州",
  东莞: "东莞",
  佛山: "佛山",
  珠海: "珠海",
  惠州: "惠州",
  江苏: "江苏",
  南京: "南京",
  苏州: "苏州",
  无锡: "无锡",
  常州: "常州",
  南通: "南通",
  扬州: "扬州",
  浙江: "浙江",
  杭州: "杭州",
  宁波: "宁波",
  温州: "温州",
  嘉兴: "嘉兴",
  绍兴: "绍兴",
  金华: "金华",
  山东: "山东",
  济南: "济南",
  青岛: "青岛",
  烟台: "烟台",
  潍坊: "潍坊",
  淄博: "淄博",
  威海: "威海",
  福建: "福建",
  福州: "福州",
  厦门: "厦门",
  泉州: "泉州",
  漳州: "漳州",
  莆田: "莆田",
  龙岩: "龙岩",
  安徽: "安徽",
  合肥: "合肥",
  芜湖: "芜湖",
  蚌埠: "蚌埠",
  马鞍山: "马鞍山",
  滁州: "滁州",
  安庆: "安庆",
  湖北: "湖北",
  武汉: "武汉",
  宜昌: "宜昌",
  襄阳: "襄阳",
  黄石: "黄石",
  荆州: "荆州",
  孝感: "孝感",
  湖南: "湖南",
  长沙: "长沙",
  株洲: "株洲",
  湘潭: "湘潭",
  岳阳: "岳阳",
  衡阳: "衡阳",
  常德: "常德",
  四川: "四川",
  成都: "成都",
  绵阳: "绵阳",
  德阳: "德阳",
  宜宾: "宜宾",
  乐山: "乐山",
  南充: "南充",
  陕西: "陕西",
  西安: "西安",
  宝鸡: "宝鸡",
  咸阳: "咸阳",
  渭南: "渭南",
  汉中: "汉中",
  榆林: "榆林",
  河南: "河南",
  郑州: "郑州",
  洛阳: "洛阳",
  新乡: "新乡",
  许昌: "许昌",
  南阳: "南阳",
  安阳: "安阳",
  河北: "河北",
  石家庄: "石家庄",
  唐山: "唐山",
  保定: "保定",
  廊坊: "廊坊",
  沧州: "沧州",
  邯郸: "邯郸",
  辽宁: "辽宁",
  沈阳: "沈阳",
  大连: "大连",
  鞍山: "鞍山",
  营口: "营口",
  丹东: "丹东",
  锦州: "锦州",
  江西: "江西",
  南昌: "南昌",
  赣州: "赣州",
  九江: "九江",
  上饶: "上饶",
  宜春: "宜春",
  吉安: "吉安",
  广西: "广西",
  南宁: "南宁",
  柳州: "柳州",
  桂林: "桂林",
  北海: "北海",
  玉林: "玉林",
  梧州: "梧州",
  美国: "美国",
  加利福尼亚州: "加利福尼亚州",
  洛杉矶: "洛杉矶",
  旧金山: "旧金山",
  圣何塞: "圣何塞",
  得克萨斯州: "得克萨斯州",
  奥斯汀: "奥斯汀",
  达拉斯: "达拉斯",
  休斯敦: "休斯敦",
  纽约州: "纽约州",
  纽约: "纽约",
  布法罗: "布法罗",
  奥尔巴尼: "奥尔巴尼",
  日本: "日本",
  东京都: "东京都",
  八王子: "八王子",
  町田: "町田",
  立川: "立川",
  大阪府: "大阪府",
  大阪: "大阪",
  堺: "堺",
  吹田: "吹田",
  爱知县: "爱知县",
  名古屋: "名古屋",
  丰田: "丰田",
  冈崎: "冈崎",
  新加坡: "新加坡",
  中区: "中区",
  碧山: "碧山",
  女皇镇: "女皇镇",
  大巴窑: "大巴窑",
  东区: "东区",
  淡滨尼: "淡滨尼",
  勿洛: "勿洛",
  巴西立: "巴西立",
  西区: "西区",
  裕廊东: "裕廊东",
  裕廊西: "裕廊西",
  金文泰: "金文泰",
  "归属未知（演示）": "归属未知（演示）",
});
